import axios from 'axios'
import configs from '~/configs'

export const APP_NAME = 'Re.Monster'
export const ROWS_PER_PAGE_OPTIONS = [10, 20, 30, 50]
export const NOTIFICATION_DURATION = 3
export const IMAGE_FALLBACK =
  'data:image/png;base64,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'

export const ALLOW_AVATAR_TYPES = ['image/jpeg', 'image/png', 'image/heic']

export const MONSTER_SEED = [
  'Faireaf',
  'AstarCats',
  'DEKAUSA(ALKEMON)',
  'Sake Barrel PlanetMan(PlanetmMan)',
  'Golem',
  'SignWitch(Astar Sign Witch)',
  'Layla(Love Addicted Girls)',
  'UPA(Debreed)',
  'Tofu',
  'ODENPETS(ODENDAO)',
  'Kids Hero(Kids Fight)',
  'Kids Vilain(Kids Fight)',
  'P-1(X-soldiers)',
  'Unicorn',
  'Hiyori(Wafuku)',
  'CCT(candyconytown)',
  'Ame-chan(KawaiiGirl)',
  'Valius',
  'Yamato(1912)',
  'Icelime(EIEN)',
  'Ossan Paradise',
]

export const LIST_CHAIN = ['polygon', 'ethereum', 'astar', 'arbitrum']
export const LIST_TOKEN_STANDARD = ['erc-721', 'erc-1155']
export const okButtonStyle = {
  fontWeight: 'bold',
  padding: '10px',
  color: '#fff',
  backgroundColor: '#FAA52C',
  width: '50%',
  height: '48px',
  borderRadius: '4px',
}

export const cancelButtonStyle = {
  fontWeight: 'bold',
  padding: '10px',
  color: '#fff',
  width: '50%',
  height: '48px',
  background: 'transparent',
  border: 'none',
}

export const ACTIVE_ALL_ITEM = [
  'ENERGY_BANANA_SHOP',
  'REFRESH_HERB_SHOP',
  'GENERAL_BOX',
  'FAIRY_BERRY_SHOP',
  'CARAMEL_CAKE_SHOP',
  'CHIA_YOGURT_SHOP',
  'SATIETY_KONJACT_SHOP',
  'GLORIOUS_MEAT_SHOP',
  'SUNNY_BLOSSOM_SHOP',
  'LUNAR_GRASS_SHOP',
]

export const DEFAULT_ACTIVE_ITEM = [
  'ENERGY_BANANA_SHOP',
  'REFRESH_HERB_SHOP',
  'GENERAL_BOX',
  'FAIRY_BERRY_SHOP',
  'CARAMEL_CAKE_SHOP',
  'CHIA_YOGURT_SHOP',
  'SATIETY_KONJACT_SHOP',
  'GLORIOUS_MEAT_SHOP',
  'SUNNY_BLOSSOM_SHOP',
  'LUNAR_GRASS_SHOP',
]
export const DEFAULT_ACTIVE_GAME_MONETIZATION = [
  'revenue',
  'monster_mint',
  'nft_repair',
  'shop',
  'guild',
  'change_guild',
]
//revenue // monster_mint // nft_repair //genesis_box //general_box //farm //bit
export const DEFAULT_ACTIVE_GAME_MONETIZATION_REVENUE = [
  // 'fiat',
  // 'oas',
  // 'count',
  // 'average_per_user',
]
//guild // change_guild
export const DEFAULT_ACTIVE_GAME_MONETIZATION_GUILD = [
  // 'fiat', 'oas', 'count'
]
export const DEFAULT_ACTIVE_GAME_USER = [
  // 'new_user_today',
  // 'total_user',
  // 'active_user',
  // // 'retention_rate',
  // 'average_play_time',
  // 'average_play_count',
  // 'time_zone_distribution',
  // 'number_of_sms_verification',
]
export const DEFAULT_ACTIVE_GAME_GAMEPLAY = [
  'number_of_login_days',
  'player_rank',
  'time_passed_in_game',
  'chosen_meal',
  'training_count',
  'intensive_training_count',
  'tournament_battle_count',
  'tournament_battle_win_count',
  'tournament_battle_loss_count',
  'rest_count',
  'hospital_count',
  'exploration_count',
  'amount_of_items_found_during_exploration',
  'bit_earned',
  'bit_used',
  'regeneration_ticket_earned',
  'regeneration_ticket_used',
  'tournament_ticket_earned',
  'tournament_ticket_used',
  'exploration_ticket_earned',
  'exploration_ticket_used',
]
//number_of_login_days // time_passed_in_game //hp //str //int //dex //agi //vit //dustblade //mystic_forest //skypeak //windland //greenfield //ash_valley //silver_lake //mirage_cove //lostland
//a //b //c //d //e //f
//rest_count //hospital_count //bit_earned //bit_used
//crystalization_count // used_crystalize
//coach_count //coach_used
//number_of_farm
export const DEFAULT_ACTIVE_GAME_TOTAL_AVERAGE = [
  // 'total', 'average'
]
//player_rank
export const DEFAULT_ACTIVE_GAME_GAMEPLAY_PLAYER_RANK = [
  // 'beginner',
  // 'beginner_plus',
  // 'intermediate',
  // 'intermediate_plus',
  // 'advance',
  // 'advance_plus',
  // 'expert',
  // 'master',
  // 'legend',
]
//chosen_meal
export const DEFAULT_ACTIVE_GAME_GAMEPLAY_CHOSEN_MEAL = [
  // 'none',
  // 'vegetable',
  // 'meat',
  // 'fish',
  // 'supplement',
  // 'dessert',
]
export const DEFAULT_ACTIVE_GAME_MONSTER = [
  // 'used_in_rank_match',
  // 'win_rank_match',
  // 'lose_rank_match',
  // 'used_in_tournament',
  // 'win_tournament',
  // 'training_item_use',
  // 'average_overall',
  // 'max_basic_parameter',
]
//current_monster //current_memory //total_monster
export const DEFAULT_ACTIVE_GAME_MONSTER_TOTAL = [
  // 'total', 'average'
]
//monster_training_completed
export const DEFAULT_ACTIVE_GAME_MONSTER_TOTAL_TRAINING = [
  // 'total',
  // 'average',
  // 'percentage',
]
//monster_rank
//monster_rank_crystalized
// /monster_rank_coached
export const DEFAULT_ACTIVE_GAME_MONSTER_RANK = [
  // 'f',
  // 'e',
  // 'd',
  // 'c',
  // 'b',
  // 'a',
  // 's',
]
//average_basic_parameter
//average_basic_crystalize_parameter
//average_basic_crystalize_parameter_used
//average_basic_coach_parameter
//average_basic_coach_parameter_used
//parameter_selected_coach
//parameter_used_coach
export const DEFAULT_ACTIVE_GAME_MONSTER_AVERAGE = [
  // 'hp',
  // 'str',
  // 'int',
  // 'dex',
  // 'agi',
  // 'vit',
]
//personality
export const DEFAULT_ACTIVE_GAME_MONSTER_PERSONALITY = [
  // 'Adventurer',
  // 'Brave',
  // 'Cool',
  // 'Curious',
  // 'Devoted',
  // 'Dreamer',
  // 'Emotional',
  // 'Foodie',
  // 'Gentle',
  // 'Graceful',
  // 'Innocent',
  // 'Jolly',
  // 'Lazy',
  // 'Loyal',
  // 'Naive',
  // 'Optimist',
  // 'Panicky',
  // 'Serious',
  // 'Shy',
  // 'Stubborn',
]
//innate_traits
export const DEFAULT_ACTIVE_GAME_MONSTER_INNATE_TRAITS = [
  // 'Adaptability',
  // 'Agility',
  // 'Armor_Thrust',
  // 'Strike_Aptitude',
  // 'Strike_Mastery',
  // 'Coaching',
  // 'Concentration',
  // 'Contrarian',
  // 'Converging_Muscles',
  // 'Earth_Aptitude',
  // 'Earth_Mastery',
  // 'Elemental_Body',
  // 'Flame_Aptitude',
  // 'Flame_Mastery',
  // 'Flexible_Body',
  // 'Fountain_Of_Wisdom',
  // 'Genius',
  // 'Healing_Wave',
  // 'Healthy_Body',
  // 'Hyper_Reactivity',
  // 'Inheritance',
  // 'Insight',
  // 'Iron_heart',
  // 'Lightning',
  // 'Longevity',
  // 'None',
  // 'Thrust_Mastery',
  // 'Slash_Mastery',
  // 'Slashing_Aptitude',
  // 'Sniper',
  // 'Strong_Heart',
  // 'Support_Master',
  // 'Surviver',
  // 'Take_a_chance',
  // 'Talent_for_Sleep',
  // 'Thrust_Aptitude',
  // 'Treasure_Hunter',
  // 'Water_Aptitude',
  // 'Water_Mastery',
  // 'Wind_Aptitude',
  // 'Wind_Mastery',
]

//accquired_traits
export const DEFAULT_ACTIVE_GAME_MONSTER_ACCQUIRED_TRAITS = [
  // 'AGI_Plus',
  // 'AVD_Plus',
  // 'CRI_Plus',
  // 'DEX_Plus',
  // 'Earth_RES_Plus',
  // 'Fire_RES_Plus',
  // 'HIT_Plus',
  // 'HP_Plus',
  // 'INT_Plus',
  // 'MND_Plus',
  // 'None',
  // 'RES_Plus',
  // 'Slash_RES_Plus',
  // 'SPD_Plus',
  // 'ST_Plus',
  // 'STR_Plus',
  // 'Strike_Res_Plus',
  // 'Thrust_RES_Plus',
  // 'VIT_Plus',
  // 'Water_RES_Plus',
  // 'Wind_RES_Plus',
]
export const DEFAULT_ACTIVE_GAME_CRYSTALIZE = [
  // 'crystalizeed_monster',
  // 'average_crystalize_overall',
  // 'max_crystalize_overall',
  // 'total_crystalize_trait',
  // 'used_crystalize_trait',
]
export const DEFAULT_ACTIVE_GAME_COACH = [
  // 'coach_monster',
  // 'average_coach_overall',
  // 'max_coach_overall',
]
export const DEFAULT_ACTIVE_GAME_FARM = [
  // 'farm_boots_item_used'
]
//farm_basic_enhance_value
//farm_potential
//farm_max_enhance_value
//special_training_value
export const DEFAULT_ACTIVE_GAME_FARM_BASIC = [
  // 'health',
  // 'strength',
  // 'intelligent',
  // 'dexterity',
  // 'agility',
  // 'vitality',
]
//farm_average_parameter
export const DEFAULT_ACTIVE_GAME_FARM_AVERAGE_PARAMETER = [
  // 'farm_stress_enhance_value',
  // 'farm_fatigue_enhance_value',
  // 'farm_rest_enhance_value',
  // 'farm_max_stress_enhance_value',
  // 'farm_max_fatigue_enhance_value',
  // 'farm_max_rest_enhance_value',
]
//farm_trait_id
export const DEFAULT_ACTIVE_GAME_FARM_TRAIT_ID = [
  // 'None',
  // 'AGI_Plus',
  // 'AVD_Plus',
  // 'Strike_RES_Plus',
  // 'CRI_Plus',
  // 'DEX_Plus',
  // 'Earth_RES_Plus',
  // 'Fire_RES_Plus',
  // 'HIT_Plus',
  // 'HP_Plus',
  // 'INT_Plus',
  // 'MND_Plus',
  // 'RES_Plus',
  // 'Slash_RES_Plus',
  // 'SPD_Plus',
  // 'ST_Plus',
  // 'STR_Plus',
  // 'Thrust_RES_Plus',
  // 'VIT_Plus',
  // 'Water_RES_Plus',
  // 'Wind_RES_Plus',
]
export const DEFAULT_ACTIVE_GAME_ITEM = [
  // 'item_mint_count',
  // 'item_used_count',
  // 'item_distribution',
  // 'item_acquisition',
]
export const ACTIVE_ALL_ASSET_TYPE = [
  configs.ADDRESS_MONSTER,
  configs.ADDRESS_FARM,
  configs.ADDRESS_GENESIS,
  configs.ADDRESS_GENERAL,
  configs.ADDRESS_REGENERATION_ITEM,
  configs.ADDRESS_FUSION_ITEM,
  configs.ADDRESS_TRAINING_ITEM,
  configs.ADDRESS_ENHANCE_ITEM,
]
export const ACTIVE_ALL_EVENT = ['OrderCreated', 'OrderSuccessful']
export const DEFAULT_ACTIVE_ASSET_TYPE = []

export const HASHCHIP_TYPE_SELECT = ['history', 'process']
export const LIST_COLLECTION = [
  'Training_Item',
  'Enhance_Item',
  'Fusion_Item',
  'Regeneration_Item',
  // 'Shop_Item',
]
export const converChain = (chain) => {
  switch (chain) {
    case 'ethereum':
      return 'Ethereum'
    case 'polygon':
      return 'Polygon'
    case 'astar':
      return 'Astar'
    case 'arbitrum':
      return 'Arbitrum'
    default:
      return ''
  }
}

export const converUserRankUser = (userRank) => {
  switch (userRank) {
    case 0:
      return 'Beginner'
    case 1:
      return 'Beginner+'
    case 2:
      return 'Intermediate'
    case 3:
      return 'Intermediate+'
    case 4:
      return 'Advance'
    case 5:
      return 'Advance+'
    case 6:
      return 'Expert'
    case 7:
      return 'Master'
    case 8:
      return 'Legend'
    default:
      return ''
  }
}
export const converRole = (role) => {
  switch (role) {
    case 0:
      return 'Guild Master'
    case 1:
      return 'Sub Master 1'
    case 2:
      return 'Sub Master 2'
    case 3:
      return 'Sub Master 3'
    case 4:
      return 'Role Custom'
    case 5:
      return 'General'
    default:
      return ''
  }
}
export const converSeed = (seed) => {
  switch (seed) {
    case 0:
      return 'Default'
    case 1:
      return 'Faireaf'
    case 2:
      return 'Golem'
    case 3:
      return 'Tofu'
    case 4:
      return 'Unicorn'
    case 5:
      return 'Valius'
    case 6:
      return 'Astar Cats'
    case 7:
      return 'Sign Witch'
    case 8:
      return 'Layla'
    case 9:
      return 'ODENPETS'
    case 10:
      return 'UPA'
    case 11:
      return 'Hiyori'
    case 12:
      return 'Yamato'
    case 13:
      return 'DEKAUSA'
    case 14:
      return 'Candy Cony Town'
    case 15:
      return 'Icelime'
    case 16:
      return 'Ame-chan'
    case 17:
      return 'Kids Hero'
    case 18:
      return 'Kids Villian'
    case 19:
      return 'Sake Barral PlanetMan'
    case 20:
      return 'P-1'
    case 21:
      return 'Ossan Paradise'
    default:
      return ''
  }
}

export const CATEGORY_GAME = [
  'user',
  'monetization',
  // 'market',
  'game_play',
  'regeneration',
  'fusion',
  'monster',
  'crystalize',
  'coach',
  'donate',
  'farm',
  'item',
  // 'issue',
]
export const itemsGameDashboard = [
  {
    value: 'user',
    key: 'user',
    label: 'User',
    children: [
      {
        value: 'new_user_today',
        key: 'new_user_today',
        label: 'New user',
      },
      {
        value: 'total_user',
        key: 'total_user',
        label: 'Total users',
      },
      {
        value: 'active_user',
        key: 'active_user',
        label: 'Active users',
      },
      {
        value: 'average_play_time',
        key: 'average_play_time',
        label: 'Average play time',
      },
      {
        value: 'average_play_count',
        key: 'average_play_count',
        label: 'Average play counts',
      },
      {
        value: 'time_zone_distribution',
        key: 'time_zone_distribution',
        label: 'Time zone distribution of access',
      },
      {
        value: 'retention_rate',
        key: 'retention_rate',
        label: 'Retention rate',
      },
      {
        value: 'location',
        key: 'location',
        label: 'Location',
      },
      {
        value: 'twitter_integration_count',
        key: 'twitter_integration_count',
        label: 'Twitter integration count',
      },
      {
        value: 'number_of_sms_verification',
        key: 'number_of_sms_verification',
        label: 'Numbers of SMS verifications',
      },
      // {
      //   value: 'number_of_email_verification',
      //   key: 'number_of_email_verification',
      //   label: 'Numbers of email verifications',
      // },
    ],
  },
  {
    value: 'monetization',
    key: 'monetization',
    label: 'Monetization(OAS)',
    children: [
      {
        value: 'revenue',
        key: 'revenue',
        label: 'Revenue',
        children: [
          {
            value: 'fiat',
            key: 'revenue_fiat',
            label: 'Fiat',
          },
          {
            value: 'oas',
            key: 'revenue_oas',
            label: 'OAS',
          },
          {
            value: 'count',
            key: 'revenue_count',
            label: 'Count',
          },
          {
            value: 'average_per_user',
            key: 'revenue_average_per_user',
            label: 'Average per user',
          },
        ],
      },
      {
        value: 'monster_mint',
        key: 'monster_mint',
        label: 'Monster Mint',
        children: [
          {
            value: 'fiat',
            key: 'monster_mint_fiat',
            label: 'Fiat',
          },
          {
            value: 'oas',
            key: 'monster_mint_oas',
            label: 'OAS',
          },
          {
            value: 'count',
            key: 'monster_mint_count',
            label: 'Count',
          },
          {
            value: 'average_per_user',
            key: 'monster_mint_average_per_user',
            label: 'Average per user',
          },
        ],
      },
      {
        value: 'nft_repair',
        key: 'nft_repair',
        label: 'NFT Repair',
        children: [
          {
            value: 'fiat',
            key: 'nft_repair_fiat',
            label: 'Fiat',
          },
          {
            value: 'oas',
            key: 'nft_repair_oas',
            label: 'OAS',
          },
          {
            value: 'count',
            key: 'nft_repair_count',
            label: 'Count',
          },
          {
            value: 'average_per_user',
            key: 'nft_repair_average_per_user',
            label: 'Average per user',
          },
        ],
      },
      {
        value: 'shop',
        key: 'shop',
        label: 'Shop',
        children: [
          {
            value: 'genesis_box',
            key: 'genesis_box',
            label: 'Genesis Box',
            children: [
              {
                value: 'fiat',
                key: 'genesis_box_fiat',
                label: 'Fiat',
              },
              {
                value: 'oas',
                key: 'genesis_box_oas',
                label: 'OAS',
              },
              {
                value: 'count',
                key: 'genesis_box_count',
                label: 'Count',
              },
              {
                value: 'average_per_user',
                key: 'genesis_box_average_per_user',
                label: 'Average per user',
              },
            ],
          },
          {
            value: 'general_box',
            key: 'general_box',
            label: 'General Box',
            children: [
              {
                value: 'fiat',
                key: 'general_box_fiat',
                label: 'Fiat',
              },
              {
                value: 'oas',
                key: 'general_box_oas',
                label: 'OAS',
              },
              {
                value: 'count',
                key: 'general_box_count',
                label: 'Count',
              },
              {
                value: 'average_per_user',
                key: 'general_box_average_per_user',
                label: 'Average per user',
              },
            ],
          },
          {
            value: 'farm',
            key: 'farm',
            label: 'Farm',
            children: [
              {
                value: 'fiat',
                key: 'farm_fiat',
                label: 'Fiat',
              },
              {
                value: 'oas',
                key: 'farm_oas',
                label: 'OAS',
              },
              {
                value: 'count',
                key: 'farm_count',
                label: 'Count',
              },
              {
                value: 'average_per_user',
                key: 'farm_average_per_user',
                label: 'Average per user',
              },
            ],
          },
          {
            value: 'bit',
            key: 'bit',
            label: 'BIT',
            children: [
              {
                value: 'fiat',
                key: 'bit_fiat',
                label: 'Fiat',
              },
              {
                value: 'oas',
                key: 'bit_oas',
                label: 'OAS',
              },
              {
                value: 'count',
                key: 'bit_count',
                label: 'Count',
              },
              {
                value: 'average_per_user',
                key: 'bit_average_per_user',
                label: 'Average per user',
              },
            ],
          },
        ],
      },
      {
        value: 'guild',
        key: 'guild',
        label: 'Guild',
        children: [
          {
            value: 'fiat',
            key: 'guild_fiat',
            label: 'Fiat',
          },
          {
            value: 'oas',
            key: 'guild_oas',
            label: 'OAS',
          },
          {
            value: 'count',
            key: 'guild_count',
            label: 'Count',
          },
        ],
      },
      {
        value: 'change_guild',
        key: 'change_guild',
        label: 'Change Guild',
        children: [
          {
            value: 'fiat',
            key: 'change_guild_fiat',
            label: 'Fiat',
          },
          {
            value: 'oas',
            key: 'change_guild_oas',
            label: 'OAS',
          },
          {
            value: 'count',
            key: 'change_guild_count',
            label: 'Count',
          },
        ],
      },
    ],
  },
  {
    value: 'game_play',
    key: 'game_play',
    label: 'Game Play',
    children: [
      {
        value: 'number_of_login_days',
        key: 'number_of_login_days',
        label: 'Number of login days',
        children: [
          {
            value: 'total',
            key: 'number_of_login_days_total',
            label: 'Total',
          },
          {
            value: 'average',
            key: 'number_of_login_days_average',
            label: 'Average',
          },
        ],
      },
      {
        value: 'player_rank',
        key: 'player_rank',
        label: 'Player rank',
        children: [
          {
            value: 'beginner',
            key: 'player_rank_beginner',
            label: 'Beginner',
          },
          {
            value: 'beginner_plus',
            key: 'player_rank_beginner_plus',
            label: 'Beginner plus',
          },
          {
            value: 'intermediate',
            key: 'player_rank_intermediate',
            label: 'Intermediate',
          },
          {
            value: 'intermediate_plus',
            key: 'player_rank_intermediate_plus',
            label: 'Intermediate plus',
          },
          {
            value: 'advance',
            key: 'player_rank_advance',
            label: 'Advance',
          },
          {
            value: 'advance_plus',
            key: 'player_rank_advance_plus',
            label: 'Advance plus',
          },
          {
            value: 'expert',
            key: 'player_rank_expert',
            label: 'Expert',
          },
          {
            value: 'master',
            key: 'player_rank_master',
            label: 'Master',
          },
          {
            value: 'legend',
            key: 'player_rank_legend',
            label: 'Legend',
          },
        ],
      },
      {
        value: 'time_passed_in_game',
        key: 'time_passed_in_game',
        label: 'Time passed in game',
        children: [
          {
            value: 'total',
            key: 'time_passed_in_game_total',
            label: 'Total',
          },
          {
            value: 'average',
            key: 'time_passed_in_game_average',
            label: 'Average',
          },
        ],
      },
      {
        value: 'chosen_meal',
        key: 'chosen_meal',
        label: 'Chosen meal',
        children: [
          {
            value: 'none',
            key: 'chosen_meal_none',
            label: 'None',
          },
          {
            value: 'vegetable',
            key: 'chosen_meal_vegetable',
            label: 'Vegetable',
          },
          {
            value: 'meat',
            key: 'chosen_meal_meat',
            label: 'Meat',
          },
          {
            value: 'fish',
            key: 'chosen_meal_fish',
            label: 'Fish',
          },
          {
            value: 'supplement',
            key: 'chosen_meal_supplement',
            label: 'Supplement',
          },
          {
            value: 'dessert',
            key: 'chosen_meal_dessert',
            label: 'Dessert',
          },
        ],
      },
      {
        value: 'training_count',
        key: 'training_count',
        label: 'Training count',
        children: [
          {
            value: 'hp',
            key: 'training_count_hp',
            label: 'HP',
            children: [
              {
                value: 'total',
                key: 'training_count_hp_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'training_count_hp_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'str',
            key: 'training_count_str',
            label: 'STR',
            children: [
              {
                value: 'total',
                key: 'training_count_str_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'training_count_str_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'int',
            key: 'training_count_int',
            label: 'INT',
            children: [
              {
                value: 'total',
                key: 'training_count_int_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'training_count_int_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'dex',
            key: 'training_count_dex',
            label: 'DEX',
            children: [
              {
                value: 'total',
                key: 'training_count_dex_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'training_count_dex_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'agi',
            key: 'training_count_agi',
            label: 'AGI',
            children: [
              {
                value: 'total',
                key: 'training_count_agi_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'training_count_agi_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'vit',
            key: 'training_count_vit',
            label: 'VIT',
            children: [
              {
                value: 'total',
                key: 'training_count_vit_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'training_count_vit_average',
                label: 'Average',
              },
            ],
          },
        ],
      },
      {
        value: 'intensive_training_count',
        key: 'intensive_training_count',
        label: 'Intensive training count',
        children: [
          {
            value: 'dustblade',
            key: 'intensive_training_count_dustblade',
            label: 'Dustblade',
            children: [
              {
                value: 'total',
                key: 'intensive_training_count_dustblade_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'intensive_training_count_dustblade_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'whispwood',
            key: 'intensive_training_count_whispwood',
            label: 'Whispwood',
            children: [
              {
                value: 'total',
                key: 'intensive_training_count_whispwood_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'intensive_training_count_whispwood_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'mystic_forest',
            key: 'intensive_training_count_mystic_forest',
            label: 'Mystic Forest',
            children: [
              {
                value: 'total',
                key: 'intensive_training_count_mystic_forest_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'intensive_training_count_mystic_forest_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'skypeak',
            key: 'intensive_training_count_skypeak',
            label: 'Skypeak',
            children: [
              {
                value: 'total',
                key: 'intensive_training_count_skypeak_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'intensive_training_count_skypeak_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'windland',
            key: 'intensive_training_count_windland',
            label: 'Windland',
            children: [
              {
                value: 'total',
                key: 'intensive_training_count_windland_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'intensive_training_count_windland_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'greenfield',
            key: 'intensive_training_count_greenfield',
            label: 'Greenfield',
            children: [
              {
                value: 'total',
                key: 'intensive_training_count_greenfield_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'intensive_training_count_greenfield_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'ash_valley',
            key: 'intensive_training_count_ash_valley',
            label: 'Ash Valley',
            children: [
              {
                value: 'total',
                key: 'intensive_training_count_ash_valley_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'intensive_training_count_ash_valley_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'silver_lake',
            key: 'intensive_training_count_silver_lake',
            label: 'Silver Lake',
            children: [
              {
                value: 'total',
                key: 'intensive_training_count_silver_lake_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'intensive_training_count_silver_lake_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'mirage_cove',
            key: 'intensive_training_count_mirage_cove',
            label: 'Mirage Cove',
            children: [
              {
                value: 'total',
                key: 'intensive_training_count_mirage_cove_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'intensive_training_count_mirage_cove_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'lostland',
            key: 'intensive_training_count_lostland',
            label: 'Lostland',
            children: [
              {
                value: 'total',
                key: 'intensive_training_count_lostland_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'intensive_training_count_lostland_average',
                label: 'Average',
              },
            ],
          },
        ],
      },
      {
        value: 'tournament_battle_count',
        key: 'tournament_battle_count',
        label: 'Tournament battle count',
        children: [
          {
            value: 'a',
            key: 'tournament_battle_count_a',
            label: 'A',
            children: [
              {
                value: 'total',
                key: 'tournament_battle_count_a_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'tournament_battle_count_a_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'b',
            key: 'tournament_battle_count_b',
            label: 'B',
            children: [
              {
                value: 'total',
                key: 'tournament_battle_count_b_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'tournament_battle_count_b_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'c',
            key: 'tournament_battle_count_c',
            label: 'C',
            children: [
              {
                value: 'total',
                key: 'tournament_battle_count_c_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'tournament_battle_count_c_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'd',
            key: 'tournament_battle_count_d',
            label: 'D',
            children: [
              {
                value: 'total',
                key: 'tournament_battle_count_d_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'tournament_battle_count_d_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'e',
            key: 'tournament_battle_count_e',
            label: 'E',
            children: [
              {
                value: 'total',
                key: 'tournament_battle_count_e_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'tournament_battle_count_e_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'f',
            key: 'tournament_battle_count_f',
            label: 'F',
            children: [
              {
                value: 'total',
                key: 'tournament_battle_count_f_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'tournament_battle_count_f_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 's',
            key: 'tournament_battle_count_s',
            label: 'S',
            children: [
              {
                value: 'total',
                key: 'tournament_battle_count_s_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'tournament_battle_count_s_average',
                label: 'Average',
              },
            ],
          },
        ],
      },
      {
        value: 'tournament_battle_win_count',
        key: 'tournament_battle_win_count',
        label: 'Tournament battle won count',
        children: [
          {
            value: 'a',
            key: 'tournament_battle_win_count_a',
            label: 'A',
            children: [
              {
                value: 'total',
                key: 'tournament_battle_win_count_a_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'tournament_battle_win_count_a_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'b',
            key: 'tournament_battle_win_count_b',
            label: 'B',
            children: [
              {
                value: 'total',
                key: 'tournament_battle_win_count_b_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'tournament_battle_win_count_b_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'c',
            key: 'tournament_battle_win_count_c',
            label: 'C',
            children: [
              {
                value: 'total',
                key: 'tournament_battle_win_count_c_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'tournament_battle_win_count_c_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'd',
            key: 'tournament_battle_win_count_d',
            label: 'D',
            children: [
              {
                value: 'total',
                key: 'tournament_battle_win_count_d_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'tournament_battle_win_count_d_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'e',
            key: 'tournament_battle_win_count_e',
            label: 'E',
            children: [
              {
                value: 'total',
                key: 'tournament_battle_win_count_e_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'tournament_battle_win_count_e_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'f',
            key: 'tournament_battle_win_count_f',
            label: 'F',
            children: [
              {
                value: 'total',
                key: 'tournament_battle_win_count_f_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'tournament_battle_win_count_f_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 's',
            key: 'tournament_battle_win_count_s',
            label: 'S',
            children: [
              {
                value: 'total',
                key: 'tournament_battle_win_count_s_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'tournament_battle_win_count_s_average',
                label: 'Average',
              },
            ],
          },
        ],
      },
      {
        value: 'tournament_battle_loss_count',
        key: 'tournament_battle_loss_count',
        label: 'Tournament battle lost count',
        children: [
          {
            value: 'a',
            key: 'tournament_battle_loss_count_a',
            label: 'A',
            children: [
              {
                value: 'total',
                key: 'tournament_battle_loss_count_a_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'tournament_battle_loss_count_a_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'b',
            key: 'tournament_battle_loss_count_b',
            label: 'B',
            children: [
              {
                value: 'total',
                key: 'tournament_battle_loss_count_b_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'tournament_battle_loss_count_b_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'c',
            key: 'tournament_battle_loss_count_c',
            label: 'C',
            children: [
              {
                value: 'total',
                key: 'tournament_battle_loss_count_c_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'tournament_battle_loss_count_c_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'd',
            key: 'tournament_battle_loss_count_d',
            label: 'D',
            children: [
              {
                value: 'total',
                key: 'tournament_battle_loss_count_d_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'tournament_battle_loss_count_d_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'e',
            key: 'tournament_battle_loss_count_e',
            label: 'E',
            children: [
              {
                value: 'total',
                key: 'tournament_battle_loss_count_e_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'tournament_battle_loss_count_e_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'f',
            key: 'tournament_battle_loss_count_f',
            label: 'F',
            children: [
              {
                value: 'total',
                key: 'tournament_battle_loss_count_f_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'tournament_battle_loss_count_f_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 's',
            key: 'tournament_battle_loss_count_s',
            label: 'S',
            children: [
              {
                value: 'total',
                key: 'tournament_battle_loss_count_s_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'tournament_battle_loss_count_s_average',
                label: 'Average',
              },
            ],
          },
        ],
      },
      {
        value: 'ranked_match_battle_count',
        key: 'ranked_match_battle_count',
        label: 'Ranked match battle count',
        children: [
          {
            value: 'simple',
            key: 'ranked_match_battle_count_simple',
            label: 'Simple',
            children: [
              {
                value: 'total',
                key: 'ranked_match_battle_count_simple_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'ranked_match_battle_count_simple_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'prize',
            key: 'ranked_match_battle_count_prize',
            label: 'Prize',
            children: [
              {
                value: 'total',
                key: 'ranked_match_battle_count_prize_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'ranked_match_battle_count_prize_average',
                label: 'Average',
              },
            ],
          },
        ],
      },
      {
        value: 'ranked_match_selection_rank',
        key: 'ranked_match_selection_rank',
        label: 'Ranked match selection rank',
        children: [
          {
            value: 'simple',
            key: 'ranked_match_selection_rank_simple',
            label: 'Simple',
            children: [
              { value: 'a', key: 'ranked_match_selection_rank_simple_a', label: 'A' },
              { value: 'b', key: 'ranked_match_selection_rank_simple_b', label: 'B' },
              { value: 'c', key: 'ranked_match_selection_rank_simple_c', label: 'C' },
              { value: 'd', key: 'ranked_match_selection_rank_simple_d', label: 'D' },
              { value: 'e', key: 'ranked_match_selection_rank_simple_e', label: 'E' },
              { value: 'f', key: 'ranked_match_selection_rank_simple_f', label: 'F' },
              { value: 's', key: 'ranked_match_selection_rank_simple_s', label: 'S' },
            ],
          },
          {
            value: 'prize',
            key: 'ranked_match_selection_rank_prize',
            label: 'Prize',
            children: [
              { value: 'a', key: 'ranked_match_selection_rank_prize_a', label: 'A' },
              { value: 'b', key: 'ranked_match_selection_rank_prize_b', label: 'B' },
              { value: 'c', key: 'ranked_match_selection_rank_prize_c', label: 'C' },
              { value: 'd', key: 'ranked_match_selection_rank_prize_d', label: 'D' },
              { value: 'e', key: 'ranked_match_selection_rank_prize_e', label: 'E' },
              { value: 'f', key: 'ranked_match_selection_rank_prize_f', label: 'F' },
              { value: 's', key: 'ranked_match_selection_rank_prize_s', label: 'S' },
            ],
          },
        ],
      },
      {
        value: 'ranked_match_battle_win_loss',
        key: 'ranked_match_battle_win_loss',
        label: 'Ranked match battle win/loss',
        children: [
          {
            value: 'simple',
            key: 'ranked_match_battle_win_loss_simple',
            label: 'Simple',
            children: [
              {
                value: 'win',
                key: 'ranked_match_battle_win_loss_simple_win',
                label: 'Win',
                children: [
                  {
                    value: 'total',
                    key: 'ranked_match_battle_win_loss_simple_win_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'ranked_match_battle_win_loss_simple_win_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'loss',
                key: 'ranked_match_battle_win_loss_simple_loss',
                label: 'Loss',
                children: [
                  {
                    value: 'total',
                    key: 'ranked_match_battle_win_loss_simple_loss_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'ranked_match_battle_win_loss_simple_loss_average',
                    label: 'Average',
                  },
                ],
              },
            ],
          },
          {
            value: 'prize',
            key: 'ranked_match_battle_win_loss_prize',
            label: 'Prize',
            children: [
              {
                value: 'win',
                key: 'ranked_match_battle_win_loss_prize_win',
                label: 'Win',
                children: [
                  {
                    value: 'total',
                    key: 'ranked_match_battle_win_loss_prize_win_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'ranked_match_battle_win_loss_prize_win_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'loss',
                key: 'ranked_match_battle_win_loss_prize_loss',
                label: 'Loss',
                children: [
                  {
                    value: 'total',
                    key: 'ranked_match_battle_win_loss_prize_loss_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'ranked_match_battle_win_loss_prize_loss_average',
                    label: 'Average',
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        value: 'rest_count',
        key: 'rest_count',
        label: 'Rest count',
        children: [
          {
            value: 'total',
            key: 'rest_count_total',
            label: 'Total',
          },
          {
            value: 'average',
            key: 'rest_count_average',
            label: 'Average',
          },
        ],
      },
      {
        value: 'hospital_count',
        key: 'hospital_count',
        label: 'Hospital count',
        children: [
          {
            value: 'total',
            key: 'hospital_count_total',
            label: 'Total',
          },
          {
            value: 'average',
            key: 'hospital_count_average',
            label: 'Average',
          },
        ],
      },
      {
        value: 'exploration_count',
        key: 'exploration_count',
        label: 'Exploration count',
        children: [
          {
            value: 'dustblade',
            key: 'exploration_count_dustblade',
            label: 'Dustblade',
            children: [
              {
                value: 'total',
                key: 'exploration_count_dustblade_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'exploration_count_dustblade_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'whispwood',
            key: 'exploration_count_whispwood',
            label: 'Whispwood',
            children: [
              {
                value: 'total',
                key: 'exploration_count_whispwood_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'exploration_count_whispwood_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'mystic_forest',
            key: 'exploration_count_mystic_forest',
            label: 'Mystic Forest',
            children: [
              {
                value: 'total',
                key: 'exploration_count_mystic_forest_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'exploration_count_mystic_forest_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'skypeak',
            key: 'exploration_count_skypeak',
            label: 'Skypeak',
            children: [
              {
                value: 'total',
                key: 'exploration_count_skypeak_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'exploration_count_skypeak_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'windland',
            key: 'exploration_count_windland',
            label: 'Windland',
            children: [
              {
                value: 'total',
                key: 'exploration_count_windland_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'exploration_count_windland_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'greenfield',
            key: 'exploration_count_greenfield',
            label: 'Greenfield',
            children: [
              {
                value: 'total',
                key: 'exploration_count_greenfield_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'exploration_count_greenfield_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'ash_valley',
            key: 'exploration_count_ash_valley',
            label: 'Ash Valley',
            children: [
              {
                value: 'total',
                key: 'exploration_count_ash_valley_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'exploration_count_ash_valley_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'silver_lake',
            key: 'exploration_count_silver_lake',
            label: 'Silver Lake',
            children: [
              {
                value: 'total',
                key: 'exploration_count_silver_lake_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'exploration_count_silver_lake_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'mirage_cove',
            key: 'exploration_count_mirage_cove',
            label: 'Mirage Cove',
            children: [
              {
                value: 'total',
                key: 'exploration_count_mirage_cove_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'exploration_count_mirage_cove_average',
                label: 'Average',
              },
            ],
          },
          {
            value: 'lostland',
            key: 'exploration_count_lostland',
            label: 'Lostland',
            children: [
              {
                value: 'total',
                key: 'exploration_count_lostland_total',
                label: 'Total',
              },
              {
                value: 'average',
                key: 'exploration_count_lostland_average',
                label: 'Average',
              },
            ],
          },
        ],
      },
      {
        value: 'amount_of_items_found_during_exploration',
        key: 'amount_of_items_found_during_exploration',
        label: 'Amount of items found during exploration',
        children: [
          {
            value: 'dustblade',
            key: 'amount_of_items_found_during_exploration_dustblade',
            label: 'Dustblade',
            children: [
              {
                value: 'caramel_cake_c',
                key: 'amount_of_items_found_during_exploration_dustblade_caramel_cake_c',
                label: 'Caramel Cake (C)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_dustblade_caramel_cake_c_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_dustblade_caramel_cake_c_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'caramel_cake_uc',
                key: 'amount_of_items_found_during_exploration_dustblade_caramel_cake_uc',
                label: 'Caramel Cake (UC)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_dustblade_caramel_cake_uc_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_dustblade_caramel_cake_uc_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'caramel_cake_r',
                key: 'amount_of_items_found_during_exploration_dustblade_caramel_cake_r',
                label: 'Caramel Cake (R)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_dustblade_caramel_cake_r_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_dustblade_caramel_cake_r_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'glorious_meat_c',
                key: 'amount_of_items_found_during_exploration_dustblade_glorious_meat_c',
                label: 'Glorious Meat (C)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_dustblade_glorious_meat_c_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_dustblade_glorious_meat_c_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'glorious_meat_uc',
                key: 'amount_of_items_found_during_exploration_dustblade_glorious_meat_uc',
                label: 'Glorious Meat (UC)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_dustblade_glorious_meat_uc_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_dustblade_glorious_meat_uc_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'glorious_meat_r',
                key: 'amount_of_items_found_during_exploration_dustblade_glorious_meat_r',
                label: 'Glorious Meat (R)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_dustblade_glorious_meat_r_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_dustblade_glorious_meat_r_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'all_seed_c',
                key: 'amount_of_items_found_during_exploration_dustblade_all_seed_c',
                label: 'ALL Seed (C)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_dustblade_all_seed_c_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_dustblade_all_seed_c_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'all_seed_uc',
                key: 'amount_of_items_found_during_exploration_dustblade_all_seed_uc',
                label: 'ALL Seed (UC)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_dustblade_all_seed_uc_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_dustblade_all_seed_uc_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'all_seed_r',
                key: 'amount_of_items_found_during_exploration_dustblade_all_seed_r',
                label: 'ALL Seed (R)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_dustblade_all_seed_r_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_dustblade_all_seed_r_average',
                    label: 'Average',
                  },
                ],
              },
            ],
          },
          {
            value: 'whispwood',
            key: 'amount_of_items_found_during_exploration_whispwood',
            label: 'Whispwood',
            children: [
              {
                value: 'energy_banana_c',
                key: 'amount_of_items_found_during_exploration_whispwood_energy_banana_c',
                label: 'Energy Banana (C)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_whispwood_energy_banana_c_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_whispwood_energy_banana_c_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'energy_banana_uc',
                key: 'amount_of_items_found_during_exploration_whispwood_energy_banana_uc',
                label: 'Energy Banana (UC)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_whispwood_energy_banana_uc_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_whispwood_energy_banana_uc_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'energy_banana_r',
                key: 'amount_of_items_found_during_exploration_whispwood_energy_banana_r',
                label: 'Energy Banana (R)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_whispwood_energy_banana_r_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_whispwood_energy_banana_r_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'fairy_berry_c',
                key: 'amount_of_items_found_during_exploration_whispwood_fairy_berry_c',
                label: 'Fairy Berry (C)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_whispwood_fairy_berry_c_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_whispwood_fairy_berry_c_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'fairy_berry_uc',
                key: 'amount_of_items_found_during_exploration_whispwood_fairy_berry_uc',
                label: 'Fairy Berry (UC)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_whispwood_fairy_berry_uc_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_whispwood_fairy_berry_uc_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'fairy_berry_r',
                key: 'amount_of_items_found_during_exploration_whispwood_fairy_berry_r',
                label: 'Fairy Berry (R)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_whispwood_fairy_berry_r_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_whispwood_fairy_berry_r_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'int_seed_c',
                key: 'amount_of_items_found_during_exploration_whispwood_int_seed_c',
                label: 'INT Seed (C)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_whispwood_int_seed_c_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_whispwood_int_seed_c_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'int_seed_uc',
                key: 'amount_of_items_found_during_exploration_whispwood_int_seed_uc',
                label: 'INT Seed (UC)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_whispwood_int_seed_uc_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_whispwood_int_seed_uc_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'int_seed_r',
                key: 'amount_of_items_found_during_exploration_whispwood_int_seed_r',
                label: 'INT Seed (R)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_whispwood_int_seed_r_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_whispwood_int_seed_r_average',
                    label: 'Average',
                  },
                ],
              },
            ],
          },
          {
            value: 'mystic_forest',
            key: 'amount_of_items_found_during_exploration_mystic_forest',
            label: 'Mystic Forest',
            children: [
              {
                value: 'fairy_berry_c',
                key: 'amount_of_items_found_during_exploration_mystic_forest_fairy_berry_c',
                label: 'Fairy Berry (C)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_mystic_forest_fairy_berry_c_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_mystic_forest_fairy_berry_c_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'fairy_berry_uc',
                key: 'amount_of_items_found_during_exploration_mystic_forest_fairy_berry_uc',
                label: 'Fairy Berry (UC)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_mystic_forest_fairy_berry_uc_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_mystic_forest_fairy_berry_uc_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'fairy_berry_r',
                key: 'amount_of_items_found_during_exploration_mystic_forest_fairy_berry_r',
                label: 'Fairy Berry (R)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_mystic_forest_fairy_berry_r_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_mystic_forest_fairy_berry_r_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'sunny_blossom_c',
                key: 'amount_of_items_found_during_exploration_mystic_forest_sunny_blossom_c',
                label: 'Sunny Blossom (C)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_mystic_forest_sunny_blossom_c_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_mystic_forest_sunny_blossom_c_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'sunny_blossom_uc',
                key: 'amount_of_items_found_during_exploration_mystic_forest_sunny_blossom_uc',
                label: 'Sunny Blossom (UC)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_mystic_forest_sunny_blossom_uc_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_mystic_forest_sunny_blossom_uc_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'sunny_blossom_r',
                key: 'amount_of_items_found_during_exploration_mystic_forest_sunny_blossom_r',
                label: 'Sunny Blossom (R)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_mystic_forest_sunny_blossom_r_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_mystic_forest_sunny_blossom_r_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'hash_fragment_uc',
                key: 'amount_of_items_found_during_exploration_mystic_forest_hash_fragment_uc',
                label: 'Hash Fragment (UC)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_mystic_forest_hash_fragment_uc_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_mystic_forest_hash_fragment_uc_average',
                    label: 'Average',
                  },
                ],
              },
            ],
          },
          {
            value: 'skypeak',
            key: 'amount_of_items_found_during_exploration_skypeak',
            label: 'Skypeak',
            children: [
              {
                value: 'refresh_herb_c',
                key: 'amount_of_items_found_during_exploration_skypeak_refresh_herb_c',
                label: 'Refresh Herb (C)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_skypeak_refresh_herb_c_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_skypeak_refresh_herb_c_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'refresh_herb_uc',
                key: 'amount_of_items_found_during_exploration_skypeak_refresh_herb_uc',
                label: 'Refresh Herb (UC)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_skypeak_refresh_herb_uc_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_skypeak_refresh_herb_uc_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'refresh_herb_r',
                key: 'amount_of_items_found_during_exploration_skypeak_refresh_herb_r',
                label: 'Refresh Herb (R)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_skypeak_refresh_herb_r_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_skypeak_refresh_herb_r_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'satiety_konjact_c',
                key: 'amount_of_items_found_during_exploration_skypeak_satiety_konjact_c',
                label: 'Satiety Konjac (C)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_skypeak_satiety_konjact_c_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_skypeak_satiety_konjact_c_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'satiety_konjact_uc',
                key: 'amount_of_items_found_during_exploration_skypeak_satiety_konjact_uc',
                label: 'Satiety Konjac (UC)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_skypeak_satiety_konjact_uc_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_skypeak_satiety_konjact_uc_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'satiety_konjact_r',
                key: 'amount_of_items_found_during_exploration_skypeak_satiety_konjact_r',
                label: 'Satiety Konjac (R)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_skypeak_satiety_konjact_r_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_skypeak_satiety_konjact_r_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'hp_seed_c',
                key: 'amount_of_items_found_during_exploration_skypeak_hp_seed_c',
                label: 'HP Seed (C)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_skypeak_hp_seed_c_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_skypeak_hp_seed_c_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'hp_seed_uc',
                key: 'amount_of_items_found_during_exploration_skypeak_hp_seed_uc',
                label: 'HP Seed (UC)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_skypeak_hp_seed_uc_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_skypeak_hp_seed_uc_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'hp_seed_r',
                key: 'amount_of_items_found_during_exploration_skypeak_hp_seed_r',
                label: 'HP Seed (R)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_skypeak_hp_seed_r_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_skypeak_hp_seed_r_average',
                    label: 'Average',
                  },
                ],
              },
            ],
          },
          {
            value: 'windland',
            key: 'amount_of_items_found_during_exploration_windland',
            label: 'Windland',
            children: [
              {
                value: 'refresh_herb_c',
                key: 'amount_of_items_found_during_exploration_windland_refresh_herb_c',
                label: 'Refresh Herb (C)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_windland_refresh_herb_c_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_windland_refresh_herb_c_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'refresh_herb_uc',
                key: 'amount_of_items_found_during_exploration_windland_refresh_herb_uc',
                label: 'Refresh Herb (UC)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_windland_refresh_herb_uc_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_windland_refresh_herb_uc_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'refresh_herb_r',
                key: 'amount_of_items_found_during_exploration_windland_refresh_herb_r',
                label: 'Refresh Herb (R)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_windland_refresh_herb_r_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_windland_refresh_herb_r_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'satiety_konjact_c',
                key: 'amount_of_items_found_during_exploration_windland_satiety_konjact_c',
                label: 'Satiety Konjac (C)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_windland_satiety_konjact_c_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_windland_satiety_konjact_c_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'satiety_konjact_uc',
                key: 'amount_of_items_found_during_exploration_windland_satiety_konjact_uc',
                label: 'Satiety Konjac (UC)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_windland_satiety_konjact_uc_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_windland_satiety_konjact_uc_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'satiety_konjact_r',
                key: 'amount_of_items_found_during_exploration_windland_satiety_konjact_r',
                label: 'Satiety Konjac (R)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_windland_satiety_konjact_r_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_windland_satiety_konjact_r_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'str_seed_c',
                key: 'amount_of_items_found_during_exploration_windland_str_seed_c',
                label: 'STR Seed (C)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_windland_str_seed_c_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_windland_str_seed_c_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'str_seed_uc',
                key: 'amount_of_items_found_during_exploration_windland_str_seed_uc',
                label: 'STR Seed (UC)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_windland_str_seed_uc_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_windland_str_seed_uc_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'str_seed_r',
                key: 'amount_of_items_found_during_exploration_windland_str_seed_r',
                label: 'STR Seed (R)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_windland_str_seed_r_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_windland_str_seed_r_average',
                    label: 'Average',
                  },
                ],
              },
            ],
          },
          {
            value: 'greenfield',
            key: 'amount_of_items_found_during_exploration_greenfield',
            label: 'Greenfield',
            children: [
              {
                value: 'caramel_cake_c',
                key: 'amount_of_items_found_during_exploration_greenfield_caramel_cake_c',
                label: 'Caramel Cake (C)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_greenfield_caramel_cake_c_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_greenfield_caramel_cake_c_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'caramel_cake_uc',
                key: 'amount_of_items_found_during_exploration_greenfield_caramel_cake_uc',
                label: 'Caramel Cake (UC)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_greenfield_caramel_cake_uc_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_greenfield_caramel_cake_uc_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'caramel_cake_r',
                key: 'amount_of_items_found_during_exploration_greenfield_caramel_cake_r',
                label: 'Caramel Cake (R)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_greenfield_caramel_cake_r_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_greenfield_caramel_cake_r_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'sunny_blossom_c',
                key: 'amount_of_items_found_during_exploration_greenfield_sunny_blossom_c',
                label: 'Sunny Blossom (C)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_greenfield_sunny_blossom_c_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_greenfield_sunny_blossom_c_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'sunny_blossom_uc',
                key: 'amount_of_items_found_during_exploration_greenfield_sunny_blossom_uc',
                label: 'Sunny Blossom (UC)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_greenfield_sunny_blossom_uc_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_greenfield_sunny_blossom_uc_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'sunny_blossom_r',
                key: 'amount_of_items_found_during_exploration_greenfield_sunny_blossom_r',
                label: 'Sunny Blossom (R)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_greenfield_sunny_blossom_r_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_greenfield_sunny_blossom_r_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'dex_seed_c',
                key: 'amount_of_items_found_during_exploration_greenfield_dex_seed_c',
                label: 'DEX Seed (C)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_greenfield_dex_seed_c_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_greenfield_dex_seed_c_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'dex_seed_uc',
                key: 'amount_of_items_found_during_exploration_greenfield_dex_seed_uc',
                label: 'DEX Seed (UC)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_greenfield_dex_seed_uc_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_greenfield_dex_seed_uc_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'dex_seed_r',
                key: 'amount_of_items_found_during_exploration_greenfield_dex_seed_r',
                label: 'DEX Seed (R)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_greenfield_dex_seed_r_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_greenfield_dex_seed_r_average',
                    label: 'Average',
                  },
                ],
              },
            ],
          },
          {
            value: 'ash_valley',
            key: 'amount_of_items_found_during_exploration_ash_valley',
            label: 'Ash Valley',
            children: [
              {
                value: 'energy_banana_c',
                key: 'amount_of_items_found_during_exploration_ash_valley_energy_banana_c',
                label: 'Energy Banana (C)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_ash_valley_energy_banana_c_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_ash_valley_energy_banana_c_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'energy_banana_uc',
                key: 'amount_of_items_found_during_exploration_ash_valley_energy_banana_uc',
                label: 'Energy Banana (UC)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_ash_valley_energy_banana_uc_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_ash_valley_energy_banana_uc_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'energy_banana_r',
                key: 'amount_of_items_found_during_exploration_ash_valley_energy_banana_r',
                label: 'Energy Banana (R)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_ash_valley_energy_banana_r_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_ash_valley_energy_banana_r_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'lunar_grass_c',
                key: 'amount_of_items_found_during_exploration_ash_valley_lunar_grass_c',
                label: 'Lunar Grass (C)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_ash_valley_lunar_grass_c_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_ash_valley_lunar_grass_c_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'lunar_grass_uc',
                key: 'amount_of_items_found_during_exploration_ash_valley_lunar_grass_uc',
                label: 'Lunar Grass (UC)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_ash_valley_lunar_grass_uc_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_ash_valley_lunar_grass_uc_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'lunar_grass_r',
                key: 'amount_of_items_found_during_exploration_ash_valley_lunar_grass_r',
                label: 'Lunar Grass (R)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_ash_valley_lunar_grass_r_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_ash_valley_lunar_grass_r_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'all_seed_c',
                key: 'amount_of_items_found_during_exploration_ash_valley_all_seed_c',
                label: 'ALL Seed (C)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_ash_valley_all_seed_c_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_ash_valley_all_seed_c_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'all_seed_uc',
                key: 'amount_of_items_found_during_exploration_ash_valley_all_seed_uc',
                label: 'ALL Seed (UC)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_ash_valley_all_seed_uc_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_ash_valley_all_seed_uc_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'all_seed_r',
                key: 'amount_of_items_found_during_exploration_ash_valley_all_seed_r',
                label: 'ALL Seed (R)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_ash_valley_all_seed_r_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_ash_valley_all_seed_r_average',
                    label: 'Average',
                  },
                ],
              },
            ],
          },
          {
            value: 'silver_lake',
            key: 'amount_of_items_found_during_exploration_silver_lake',
            label: 'Silver Lake',
            children: [
              {
                value: 'fresh_milk_c',
                key: 'amount_of_items_found_during_exploration_silver_lake_fresh_milk_c',
                label: 'Fresh Milk (C)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_silver_lake_fresh_milk_c_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_silver_lake_fresh_milk_c_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'fresh_milk_uc',
                key: 'amount_of_items_found_during_exploration_silver_lake_fresh_milk_uc',
                label: 'Fresh Milk (UC)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_silver_lake_fresh_milk_uc_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_silver_lake_fresh_milk_uc_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'fresh_milk_r',
                key: 'amount_of_items_found_during_exploration_silver_lake_fresh_milk_r',
                label: 'Fresh Milk (R)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_silver_lake_fresh_milk_r_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_silver_lake_fresh_milk_r_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'glorious_meat_c',
                key: 'amount_of_items_found_during_exploration_silver_lake_glorious_meat_c',
                label: 'Glorious Meat (C)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_silver_lake_glorious_meat_c_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_silver_lake_glorious_meat_c_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'glorious_meat_uc',
                key: 'amount_of_items_found_during_exploration_silver_lake_glorious_meat_uc',
                label: 'Glorious Meat (UC)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_silver_lake_glorious_meat_uc_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_silver_lake_glorious_meat_uc_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'glorious_meat_r',
                key: 'amount_of_items_found_during_exploration_silver_lake_glorious_meat_r',
                label: 'Glorious Meat (R)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_silver_lake_glorious_meat_r_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_silver_lake_glorious_meat_r_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'agi_seed_c',
                key: 'amount_of_items_found_during_exploration_silver_lake_agi_seed_c',
                label: 'AGI Seed (C)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_silver_lake_agi_seed_c_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_silver_lake_agi_seed_c_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'agi_seed_uc',
                key: 'amount_of_items_found_during_exploration_silver_lake_agi_seed_uc',
                label: 'AGI Seed (UC)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_silver_lake_agi_seed_uc_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_silver_lake_agi_seed_uc_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'agi_seed_r',
                key: 'amount_of_items_found_during_exploration_silver_lake_agi_seed_r',
                label: 'AGI Seed (R)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_silver_lake_agi_seed_r_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_silver_lake_agi_seed_r_average',
                    label: 'Average',
                  },
                ],
              },
            ],
          },
          {
            value: 'mirage_cove',
            key: 'amount_of_items_found_during_exploration_mirage_cove',
            label: 'Mirage Cove',
            children: [
              {
                value: 'chia_yogurt_c',
                key: 'amount_of_items_found_during_exploration_mirage_cove_chia_yogurt_c',
                label: 'Chia Yogurt (C)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_mirage_cove_chia_yogurt_c_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_mirage_cove_chia_yogurt_c_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'chia_yogurt_uc',
                key: 'amount_of_items_found_during_exploration_mirage_cove_chia_yogurt_uc',
                label: 'Chia Yogurt (UC)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_mirage_cove_chia_yogurt_uc_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_mirage_cove_chia_yogurt_uc_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'chia_yogurt_r',
                key: 'amount_of_items_found_during_exploration_mirage_cove_chia_yogurt_r',
                label: 'Chia Yogurt (R)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_mirage_cove_chia_yogurt_r_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_mirage_cove_chia_yogurt_r_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'lunar_grass_c',
                key: 'amount_of_items_found_during_exploration_mirage_cove_lunar_grass_c',
                label: 'Lunar Grass (C)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_mirage_cove_lunar_grass_c_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_mirage_cove_lunar_grass_c_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'lunar_grass_uc',
                key: 'amount_of_items_found_during_exploration_mirage_cove_lunar_grass_uc',
                label: 'Lunar Grass (UC)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_mirage_cove_lunar_grass_uc_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_mirage_cove_lunar_grass_uc_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'lunar_grass_r',
                key: 'amount_of_items_found_during_exploration_mirage_cove_lunar_grass_r',
                label: 'Lunar Grass (R)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_mirage_cove_lunar_grass_r_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_mirage_cove_lunar_grass_r_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'life_water_c',
                key: 'amount_of_items_found_during_exploration_mirage_cove_life_water_c',
                label: 'Life Water (C)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_mirage_cove_life_water_c_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_mirage_cove_life_water_c_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'life_water_uc',
                key: 'amount_of_items_found_during_exploration_mirage_cove_life_water_uc',
                label: 'Life Water (UC)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_mirage_cove_life_water_uc_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_mirage_cove_life_water_uc_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'life_water_r',
                key: 'amount_of_items_found_during_exploration_mirage_cove_life_water_r',
                label: 'Life Water (R)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_mirage_cove_life_water_r_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_mirage_cove_life_water_r_average',
                    label: 'Average',
                  },
                ],
              },
            ],
          },
          {
            value: 'lostland',
            key: 'amount_of_items_found_during_exploration_lostland',
            label: 'Lostland',
            children: [
              {
                value: 'fresh_milk_c',
                key: 'amount_of_items_found_during_exploration_lostland_fresh_milk_c',
                label: 'Fresh Milk (C)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_lostland_fresh_milk_c_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_lostland_fresh_milk_c_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'fresh_milk_uc',
                key: 'amount_of_items_found_during_exploration_lostland_fresh_milk_uc',
                label: 'Fresh Milk (UC)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_lostland_fresh_milk_uc_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_lostland_fresh_milk_uc_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'fresh_milk_r',
                key: 'amount_of_items_found_during_exploration_lostland_fresh_milk_r',
                label: 'Fresh Milk (R)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_lostland_fresh_milk_r_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_lostland_fresh_milk_r_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'chia_yogurt_c',
                key: 'amount_of_items_found_during_exploration_lostland_chia_yogurt_c',
                label: 'Chia Yogurt (C)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_lostland_chia_yogurt_c_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_lostland_chia_yogurt_c_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'chia_yogurt_uc',
                key: 'amount_of_items_found_during_exploration_lostland_chia_yogurt_uc',
                label: 'Chia Yogurt (UC)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_lostland_chia_yogurt_uc_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_lostland_chia_yogurt_uc_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'chia_yogurt_r',
                key: 'amount_of_items_found_during_exploration_lostland_chia_yogurt_r',
                label: 'Chia Yogurt (R)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_lostland_chia_yogurt_r_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_lostland_chia_yogurt_r_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'vit_seed_c',
                key: 'amount_of_items_found_during_exploration_lostland_vit_seed_c',
                label: 'VIT Seed (C)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_lostland_vit_seed_c_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_lostland_vit_seed_c_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'vit_seed_uc',
                key: 'amount_of_items_found_during_exploration_lostland_vit_seed_uc',
                label: 'VIT Seed (UC)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_lostland_vit_seed_uc_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_lostland_vit_seed_uc_average',
                    label: 'Average',
                  },
                ],
              },
              {
                value: 'vit_seed_r',
                key: 'amount_of_items_found_during_exploration_lostland_vit_seed_r',
                label: 'VIT Seed (R)',
                children: [
                  {
                    value: 'total',
                    key: 'amount_of_items_found_during_exploration_lostland_vit_seed_r_total',
                    label: 'Total',
                  },
                  {
                    value: 'average',
                    key: 'amount_of_items_found_during_exploration_lostland_vit_seed_r_average',
                    label: 'Average',
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        value: 'bit_earned',
        key: 'bit_earned',
        label: 'In-game currency acquisition',
        children: [
          {
            value: 'total',
            key: 'bit_earned_total',
            label: 'Total',
          },
          {
            value: 'average',
            key: 'bit_earned_average',
            label: 'Average',
          },
          {
            value: 'useage',
            key: 'bit_earned_useage',
            label: 'Usage',
            children: [
              {
                value: 'reward_login_bonus',
                key: 'bit_earned_useage_reward_login_bonus',
                label: 'Login bonus reward',
              },
              {
                value: 'reward_quest',
                key: 'bit_earned_useage_reward_quest',
                label: 'Quest reward',
              },
              {
                value: 'reward_tournament',
                key: 'bit_earned_useage_reward_tournament',
                label: 'Tournament reward',
              },
              {
                value: 'prized_battle',
                key: 'bit_earned_useage_prized_battle',
                label: 'Prized battle reward',
              },
              {
                value: 'other',
                key: 'bit_earned_useage_other',
                label: 'Other',
              },
            ],
          },
        ],
      },
      {
        value: 'bit_used',
        key: 'bit_used',
        label: 'In-game currency usage',
        children: [
          {
            value: 'total',
            key: 'bit_used_total',
            label: 'Total',
          },
          {
            value: 'average',
            key: 'bit_used_average',
            label: 'Average',
          },
          {
            value: 'useage',
            key: 'bit_used_useage',
            label: 'Usage',
            children: [
              {
                value: 'training_cost',
                key: 'bit_used_useage_training_cost',
                label: 'Training cost',
              },
              {
                value: 'farm_unlock',
                key: 'bit_used_useage_farm_unlock',
                label: 'Farm unlock',
              },
              {
                value: 'crystalize',
                key: 'bit_used_useage_crystalize',
                label: 'Crystalize',
              },
              {
                value: 'monster_fusion',
                key: 'bit_used_useage_monster_fusion',
                label: 'Monster fusion',
              },
              {
                value: 'other',
                key: 'bit_used_useage_other',
                label: 'Other',
              },
            ],
          },
        ],
      },
      {
        value: 'regeneration_ticket_earned',
        key: 'regeneration_ticket_earned',
        label: 'Regeneration Ticket Acquisition',
        children: [
          {
            value: 'total',
            key: 'regeneration_ticket_earned_total',
            label: 'Total',
          },
          {
            value: 'average',
            key: 'regeneration_ticket_earned_average',
            label: 'Average',
          },
          {
            value: 'useage',
            key: 'regeneration_ticket_earned_useage',
            label: 'Usage',
            children: [
              {
                value: 'regeneration_ticket_r',
                key: 'regeneration_ticket_earned_useage_regeneration_ticket_r',
                label: 'Regeneration Ticket (Rare)',
              },
              {
                value: 'regeneration_ticket_b',
                key: 'regeneration_ticket_earned_useage_regeneration_ticket_b',
                label: 'Regeneration Ticket (Normal)',
              },
              {
                value: 'other',
                key: 'regeneration_ticket_earned_useage_other',
                label: 'Other',
              },
            ],
          },
        ],
      },
      {
        value: 'regeneration_ticket_used',
        key: 'regeneration_ticket_used',
        label: 'Regeneration Ticket Usage',
        children: [
          {
            value: 'total',
            key: 'regeneration_ticket_used_total',
            label: 'Total',
          },
          {
            value: 'average',
            key: 'regeneration_ticket_used_average',
            label: 'Average',
          },
          {
            value: 'useage',
            key: 'regeneration_ticket_used_useage',
            label: 'Usage',
            children: [
              {
                value: 'regeneration',
                key: 'regeneration_ticket_used_useage_regeneration',
                label: 'Regeneration',
              },
              {
                value: 'fusion',
                key: 'regeneration_ticket_used_useage_fusion',
                label: 'Fusion',
              },
              {
                value: 'other',
                key: 'regeneration_ticket_used_useage_other',
                label: 'Other',
              },
            ],
          },
        ],
      },
      {
        value: 'tournament_ticket_earned',
        key: 'tournament_ticket_earned',
        label: 'Tournament Ticket Acquisition',
        children: [
          {
            value: 'total',
            key: 'tournament_ticket_earned_total',
            label: 'Total',
          },
          {
            value: 'average',
            key: 'tournament_ticket_earned_average',
            label: 'Average',
          },
          {
            value: 'useage',
            key: 'tournament_ticket_earned_useage',
            label: 'Usage',
            children: [
              {
                value: 'tournament_ticket_uc',
                key: 'tournament_ticket_earned_useage_tournament_ticket_uc',
                label: 'Tournament Ticket (UC)',
              },
              {
                value: 'tournament_ticket_b',
                key: 'tournament_ticket_earned_useage_tournament_ticket_b',
                label: 'Tournament Ticket (Normal)',
              },
              {
                value: 'other',
                key: 'tournament_ticket_earned_useage_other',
                label: 'Other',
              },
            ],
          },
        ],
      },
      {
        value: 'tournament_ticket_used',
        key: 'tournament_ticket_used',
        label: 'Tournament Ticket Usage',
        children: [
          {
            value: 'total',
            key: 'tournament_ticket_used_total',
            label: 'Total',
          },
          {
            value: 'average',
            key: 'tournament_ticket_used_average',
            label: 'Average',
          },
          {
            value: 'useage',
            key: 'tournament_ticket_used_useage',
            label: 'Usage',
            children: [
              {
                value: 'tournament',
                key: 'tournament_ticket_used_useage_tournament',
                label: 'Tournament',
              },
              {
                value: 'prized_battle',
                key: 'tournament_ticket_used_useage_prized_battle',
                label: 'Prized battle',
              },
              {
                value: 'other',
                key: 'tournament_ticket_used_useage_other',
                label: 'Other',
              },
            ],
          },
        ],
      },
      {
        value: 'exploration_ticket_earned',
        key: 'exploration_ticket_earned',
        label: 'Exploration Ticket Acquisition',
        children: [
          {
            value: 'total',
            key: 'exploration_ticket_earned_total',
            label: 'Total',
          },
          {
            value: 'average',
            key: 'exploration_ticket_earned_average',
            label: 'Average',
          },
          {
            value: 'useage',
            key: 'exploration_ticket_earned_useage',
            label: 'Usage',
            children: [
              {
                value: 'exploration_ticket_uc',
                key: 'exploration_ticket_earned_useage_exploration_ticket_uc',
                label: 'Exploration Ticket (UC)',
              },
              {
                value: 'exploration_ticket_b',
                key: 'exploration_ticket_earned_useage_exploration_ticket_b',
                label: 'Exploration Ticket (Normal)',
              },
              {
                value: 'other',
                key: 'exploration_ticket_earned_useage_other',
                label: 'Other',
              },
            ],
          },
        ],
      },
      {
        value: 'exploration_ticket_used',
        key: 'exploration_ticket_used',
        label: 'Exploration Ticket Usage',
        children: [
          {
            value: 'total',
            key: 'exploration_ticket_used_total',
            label: 'Total',
          },
          {
            value: 'average',
            key: 'exploration_ticket_used_average',
            label: 'Average',
          },
          {
            value: 'useage',
            key: 'exploration_ticket_used_useage',
            label: 'Usage',
            children: [
              {
                value: 'pve_exploration',
                key: 'exploration_ticket_used_useage_pve_exploration',
                label: 'PVE Exploration',
              },
              {
                value: 'other',
                key: 'exploration_ticket_used_useage_other',
                label: 'Other',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    value: 'regeneration',
    key: 'regeneration',
    label: 'Regeneration',
    children: [
      {
        value: 'nft_mint',
        key: 'nft_mint',
        label: 'Number of mints from NFT',
        children: [
          {
            value: 'total',
            key: 'nft_mint_total',
            label: 'Total',
          },
          {
            value: 'average',
            key: 'nft_mint_average',
            label: 'Average',
          },
          {
            value: 'by_chain',
            key: 'nft_mint_by_chain',
            label: 'By Chain',
            children: [
              {
                value: 'oasys',
                key: 'nft_mint_chain_oasys',
                label: 'Oasys',
                children: [
                  { value: 'total', key: 'nft_mint_chain_oasys_total', label: 'Total' },
                  { value: 'average', key: 'nft_mint_chain_oasys_average', label: 'Average' },
                ],
              },
              {
                value: 'polygon',
                key: 'nft_mint_chain_polygon',
                label: 'Polygon',
                children: [
                  { value: 'total', key: 'nft_mint_chain_polygon_total', label: 'Total' },
                  { value: 'average', key: 'nft_mint_chain_polygon_average', label: 'Average' },
                ],
              },
              {
                value: 'astar',
                key: 'nft_mint_chain_astar',
                label: 'Astar',
                children: [
                  { value: 'total', key: 'nft_mint_chain_astar_total', label: 'Total' },
                  { value: 'average', key: 'nft_mint_chain_astar_average', label: 'Average' },
                ],
              },
              {
                value: 'ethereum',
                key: 'nft_mint_chain_ethereum',
                label: 'Ethereum',
                children: [
                  { value: 'total', key: 'nft_mint_chain_ethereum_total', label: 'Total' },
                  { value: 'average', key: 'nft_mint_chain_ethereum_average', label: 'Average' },
                ],
              },
              {
                value: 'arbitrum',
                key: 'nft_mint_chain_arbitrum',
                label: 'Arbitrum',
                children: [
                  { value: 'total', key: 'nft_mint_chain_arbitrum_total', label: 'Total' },
                  { value: 'average', key: 'nft_mint_chain_arbitrum_average', label: 'Average' },
                ],
              },
              {
                value: 'mch',
                key: 'nft_mint_chain_mch',
                label: 'MCH',
                children: [
                  { value: 'total', key: 'nft_mint_chain_mch_total', label: 'Total' },
                  { value: 'average', key: 'nft_mint_chain_mch_average', label: 'Average' },
                ],
              },
            ],
          },
          {
            value: 'by_contract',
            key: 'nft_mint_by_contract',
            label: 'By Contract (Collection)',
            children: [
              {
                value: 'oasyx',
                key: 'nft_mint_contract_0x4688e596fb8ffaa9f7c1f02985b44651cf642123',
                label: 'OASYX (Oasys)',
                children: [
                  { value: 'total', key: 'nft_mint_contract_0x4688e596fb8ffaa9f7c1f02985b44651cf642123_total', label: 'Total' },
                  { value: 'average', key: 'nft_mint_contract_0x4688e596fb8ffaa9f7c1f02985b44651cf642123_average', label: 'Average' },
                ],
              },
              {
                value: 'oasyx_maryu',
                key: 'nft_mint_contract_0xe5f5db2d1154e5bb48b9ee7478e2c46515cb0113',
                label: 'OASYX-MARYU-ZERO (Oasys)',
                children: [
                  { value: 'total', key: 'nft_mint_contract_0xe5f5db2d1154e5bb48b9ee7478e2c46515cb0113_total', label: 'Total' },
                  { value: 'average', key: 'nft_mint_contract_0xe5f5db2d1154e5bb48b9ee7478e2c46515cb0113_average', label: 'Average' },
                ],
              },
              {
                value: 'dragon_knight',
                key: 'nft_mint_contract_0x3639dc7a7c1353d7b04c5b007f038394d18397a5',
                label: 'Dragon Knight Baron (Oasys)',
                children: [
                  { value: 'total', key: 'nft_mint_contract_0x3639dc7a7c1353d7b04c5b007f038394d18397a5_total', label: 'Total' },
                  { value: 'average', key: 'nft_mint_contract_0x3639dc7a7c1353d7b04c5b007f038394d18397a5_average', label: 'Average' },
                ],
              },
              {
                value: 'defy',
                key: 'nft_mint_contract_0xfd257ddf743da7395470df9a0517a2dfbf66d156',
                label: 'DEFY Genesis Mask (Polygon)',
                children: [
                  { value: 'total', key: 'nft_mint_contract_0xfd257ddf743da7395470df9a0517a2dfbf66d156_total', label: 'Total' },
                  { value: 'average', key: 'nft_mint_contract_0xfd257ddf743da7395470df9a0517a2dfbf66d156_average', label: 'Average' },
                ],
              },
              {
                value: 'astarcats',
                key: 'nft_mint_contract_0x8b5d62f396ca3c6cf19803234685e693733f9779',
                label: 'AstarCats (Astar)',
                children: [
                  { value: 'total', key: 'nft_mint_contract_0x8b5d62f396ca3c6cf19803234685e693733f9779_total', label: 'Total' },
                  { value: 'average', key: 'nft_mint_contract_0x8b5d62f396ca3c6cf19803234685e693733f9779_average', label: 'Average' },
                ],
              },
              {
                value: 'astarsignwitch',
                key: 'nft_mint_contract_0x7b2152e51130439374672af463b735a59a47ea85',
                label: 'AstarSignWitch (Astar)',
                children: [
                  { value: 'total', key: 'nft_mint_contract_0x7b2152e51130439374672af463b735a59a47ea85_total', label: 'Total' },
                  { value: 'average', key: 'nft_mint_contract_0x7b2152e51130439374672af463b735a59a47ea85_average', label: 'Average' },
                ],
              },
              {
                value: 'astarpunks',
                key: 'nft_mint_contract_0x1b57c69838cdbc59c8236dda73287a4780b4831f',
                label: 'Astar Punks (Astar)',
                children: [
                  { value: 'total', key: 'nft_mint_contract_0x1b57c69838cdbc59c8236dda73287a4780b4831f_total', label: 'Total' },
                  { value: 'average', key: 'nft_mint_contract_0x1b57c69838cdbc59c8236dda73287a4780b4831f_average', label: 'Average' },
                ],
              },
              {
                value: 'nftpocket',
                key: 'nft_mint_contract_0x13e49711bf35f7aa1b2016b6df8ea67c16d98676',
                label: 'NFT Pocket x beyondClub (Astar)',
                children: [
                  { value: 'total', key: 'nft_mint_contract_0x13e49711bf35f7aa1b2016b6df8ea67c16d98676_total', label: 'Total' },
                  { value: 'average', key: 'nft_mint_contract_0x13e49711bf35f7aa1b2016b6df8ea67c16d98676_average', label: 'Average' },
                ],
              },
              {
                value: 'rattlehead',
                key: 'nft_mint_contract_0xc609596bd470353d1b5fa6479a1eac360112bb56',
                label: 'Rattlehead (Ethereum)',
                children: [
                  { value: 'total', key: 'nft_mint_contract_0xc609596bd470353d1b5fa6479a1eac360112bb56_total', label: 'Total' },
                  { value: 'average', key: 'nft_mint_contract_0xc609596bd470353d1b5fa6479a1eac360112bb56_average', label: 'Average' },
                ],
              },
              {
                value: 'anticipation',
                key: 'nft_mint_contract_0x15c905dec8da0a90fa05f8121e8f8285d30ef1f4',
                label: 'Anticipation (Ethereum)',
                children: [
                  { value: 'total', key: 'nft_mint_contract_0x15c905dec8da0a90fa05f8121e8f8285d30ef1f4_total', label: 'Total' },
                  { value: 'average', key: 'nft_mint_contract_0x15c905dec8da0a90fa05f8121e8f8285d30ef1f4_average', label: 'Average' },
                ],
              },
              {
                value: 'arbitrum_nft',
                key: 'nft_mint_contract_0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
                label: 'Arbitrum NFT (Arbitrum)',
                children: [
                  { value: 'total', key: 'nft_mint_contract_0x46a15b0b27311cedf172ab29e4f4766fbe7f4364_total', label: 'Total' },
                  { value: 'average', key: 'nft_mint_contract_0x46a15b0b27311cedf172ab29e4f4766fbe7f4364_average', label: 'Average' },
                ],
              },
            ],
          },
        ],
      },
      {
        value: 'nft_mint_count',
        key: 'nft_mint_count',
        label: 'NFT Mint Count',
      },
      {
        value: 'collab_nft_mint_count',
        key: 'collab_nft_mint_count',
        label: 'Collab NFT Mint Count',
      },
      {
        value: 'free_mint',
        key: 'free_mint',
        label: 'Number of Free Mints',
        children: [
          {
            value: 'total',
            key: 'free_mint_total',
            label: 'Total',
          },
          {
            value: 'average',
            key: 'free_mint_average',
            label: 'Average',
          },
        ],
      },
      {
        value: 'regeneration_hash',
        key: 'regeneration_hash',
        label: 'Number of Mints from Regeneration Hash',
        children: [
          {
            value: 'total',
            key: 'regeneration_hash_total',
            label: 'Total',
          },
          {
            value: 'average',
            key: 'regeneration_hash_average',
            label: 'Average',
          },
          {
            value: 'species',
            key: 'regeneration_hash_species',
            label: 'By Species (種類)',
            children: [
              { value: 'ame_chan', key: 'regeneration_hash_species_ame_chan', label: 'Ame-chan' },
              { value: 'astarcats', key: 'regeneration_hash_species_astarcats', label: 'AstarCats' },
              { value: 'cct', key: 'regeneration_hash_species_cct', label: 'CCT' },
              { value: 'dekausa', key: 'regeneration_hash_species_dekausa', label: 'DEKAUSA' },
              { value: 'faireaf', key: 'regeneration_hash_species_faireaf', label: 'Faireaf' },
              { value: 'golem', key: 'regeneration_hash_species_golem', label: 'Golem' },
              { value: 'hiyori', key: 'regeneration_hash_species_hiyori', label: 'Hiyori' },
              { value: 'icelime', key: 'regeneration_hash_species_icelime', label: 'Icelime' },
              { value: 'kids_hero', key: 'regeneration_hash_species_kids_hero', label: 'Kids Hero' },
              { value: 'kids_villain', key: 'regeneration_hash_species_kids_villain', label: 'Kids Villain' },
              { value: 'layla', key: 'regeneration_hash_species_layla', label: 'Layla' },
              { value: 'odenpets', key: 'regeneration_hash_species_odenpets', label: 'ODENPETS' },
              { value: 'ossan_paradise', key: 'regeneration_hash_species_ossan_paradise', label: 'Ossan Paradise' },
              { value: 'p1', key: 'regeneration_hash_species_p1', label: 'P1' },
              { value: 'planetman', key: 'regeneration_hash_species_planetman', label: 'Planetman' },
              { value: 'signwitch', key: 'regeneration_hash_species_signwitch', label: 'SignWitch' },
              { value: 'tofu', key: 'regeneration_hash_species_tofu', label: 'Tofu' },
              { value: 'unicorn', key: 'regeneration_hash_species_unicorn', label: 'Unicorn' },
              { value: 'upa', key: 'regeneration_hash_species_upa', label: 'UPA' },
              { value: 'valius', key: 'regeneration_hash_species_valius', label: 'Valius' },
              { value: 'yamato', key: 'regeneration_hash_species_yamato', label: 'Yamato' },
            ],
          },
        ],
      },
      {
        value: 'genesis_hash',
        key: 'genesis_hash',
        label: 'Number of Mints from Genesis Hash',
        children: [
          {
            value: 'total',
            key: 'genesis_hash_total',
            label: 'Total',
          },
          {
            value: 'average',
            key: 'genesis_hash_average',
            label: 'Average',
          },
          {
            value: 'species',
            key: 'genesis_hash_species',
            label: 'By Species (種類)',
            children: [
              { value: 'ame_chan', key: 'genesis_hash_species_ame_chan', label: 'Ame-chan' },
              { value: 'astarcats', key: 'genesis_hash_species_astarcats', label: 'AstarCats' },
              { value: 'cct', key: 'genesis_hash_species_cct', label: 'CCT' },
              { value: 'dekausa', key: 'genesis_hash_species_dekausa', label: 'DEKAUSA' },
              { value: 'faireaf', key: 'genesis_hash_species_faireaf', label: 'Faireaf' },
              { value: 'golem', key: 'genesis_hash_species_golem', label: 'Golem' },
              { value: 'hiyori', key: 'genesis_hash_species_hiyori', label: 'Hiyori' },
              { value: 'icelime', key: 'genesis_hash_species_icelime', label: 'Icelime' },
              { value: 'kids_hero', key: 'genesis_hash_species_kids_hero', label: 'Kids Hero' },
              { value: 'kids_villain', key: 'genesis_hash_species_kids_villain', label: 'Kids Villain' },
              { value: 'layla', key: 'genesis_hash_species_layla', label: 'Layla' },
              { value: 'odenpets', key: 'genesis_hash_species_odenpets', label: 'ODENPETS' },
              { value: 'ossan_paradise', key: 'genesis_hash_species_ossan_paradise', label: 'Ossan Paradise' },
              { value: 'p1', key: 'genesis_hash_species_p1', label: 'P1' },
              { value: 'planetman', key: 'genesis_hash_species_planetman', label: 'Planetman' },
              { value: 'signwitch', key: 'genesis_hash_species_signwitch', label: 'SignWitch' },
              { value: 'tofu', key: 'genesis_hash_species_tofu', label: 'Tofu' },
              { value: 'unicorn', key: 'genesis_hash_species_unicorn', label: 'Unicorn' },
              { value: 'upa', key: 'genesis_hash_species_upa', label: 'UPA' },
              { value: 'valius', key: 'genesis_hash_species_valius', label: 'Valius' },
              { value: 'yamato', key: 'genesis_hash_species_yamato', label: 'Yamato' },
            ],
          },
        ],
      },
      {
        value: 'general_hash',
        key: 'general_hash',
        label: 'Number of Mints from Group Hash',
        children: [
          {
            value: 'total',
            key: 'general_hash_total',
            label: 'Total',
          },
          {
            value: 'average',
            key: 'general_hash_average',
            label: 'Average',
          },
          {
            value: 'species',
            key: 'general_hash_species',
            label: 'By Species (種類)',
            children: [
              { value: 'ame_chan', key: 'general_hash_species_ame_chan', label: 'Ame-chan' },
              { value: 'astarcats', key: 'general_hash_species_astarcats', label: 'AstarCats' },
              { value: 'cct', key: 'general_hash_species_cct', label: 'CCT' },
              { value: 'dekausa', key: 'general_hash_species_dekausa', label: 'DEKAUSA' },
              { value: 'faireaf', key: 'general_hash_species_faireaf', label: 'Faireaf' },
              { value: 'golem', key: 'general_hash_species_golem', label: 'Golem' },
              { value: 'hiyori', key: 'general_hash_species_hiyori', label: 'Hiyori' },
              { value: 'icelime', key: 'general_hash_species_icelime', label: 'Icelime' },
              { value: 'kids_hero', key: 'general_hash_species_kids_hero', label: 'Kids Hero' },
              { value: 'kids_villain', key: 'general_hash_species_kids_villain', label: 'Kids Villain' },
              { value: 'layla', key: 'general_hash_species_layla', label: 'Layla' },
              { value: 'odenpets', key: 'general_hash_species_odenpets', label: 'ODENPETS' },
              { value: 'ossan_paradise', key: 'general_hash_species_ossan_paradise', label: 'Ossan Paradise' },
              { value: 'p1', key: 'general_hash_species_p1', label: 'P1' },
              { value: 'planetman', key: 'general_hash_species_planetman', label: 'Planetman' },
              { value: 'signwitch', key: 'general_hash_species_signwitch', label: 'SignWitch' },
              { value: 'tofu', key: 'general_hash_species_tofu', label: 'Tofu' },
              { value: 'unicorn', key: 'general_hash_species_unicorn', label: 'Unicorn' },
              { value: 'upa', key: 'general_hash_species_upa', label: 'UPA' },
              { value: 'valius', key: 'general_hash_species_valius', label: 'Valius' },
              { value: 'yamato', key: 'general_hash_species_yamato', label: 'Yamato' },
            ],
          },
        ],
      },
      {
        value: 'hash_chip_nft',
        key: 'hash_chip_nft',
        label: 'Number of mints from Hash Chip NFT',
        children: [
          {
            value: 'total',
            key: 'hash_chip_nft_total',
            label: 'Total',
          },
          {
            value: 'average',
            key: 'hash_chip_nft_average',
            label: 'Average',
          },
          {
            value: 'species',
            key: 'hash_chip_nft_species',
            label: 'By Species (種類)',
            children: [
              { value: 'ame_chan', key: 'hash_chip_nft_species_ame_chan', label: 'Ame-chan' },
              { value: 'astarcats', key: 'hash_chip_nft_species_astarcats', label: 'AstarCats' },
              { value: 'cct', key: 'hash_chip_nft_species_cct', label: 'CCT' },
              { value: 'dekausa', key: 'hash_chip_nft_species_dekausa', label: 'DEKAUSA' },
              { value: 'faireaf', key: 'hash_chip_nft_species_faireaf', label: 'Faireaf' },
              { value: 'golem', key: 'hash_chip_nft_species_golem', label: 'Golem' },
              { value: 'hiyori', key: 'hash_chip_nft_species_hiyori', label: 'Hiyori' },
              { value: 'icelime', key: 'hash_chip_nft_species_icelime', label: 'Icelime' },
              { value: 'kids_hero', key: 'hash_chip_nft_species_kids_hero', label: 'Kids Hero' },
              { value: 'kids_villain', key: 'hash_chip_nft_species_kids_villain', label: 'Kids Villain' },
              { value: 'layla', key: 'hash_chip_nft_species_layla', label: 'Layla' },
              { value: 'odenpets', key: 'hash_chip_nft_species_odenpets', label: 'ODENPETS' },
              { value: 'ossan_paradise', key: 'hash_chip_nft_species_ossan_paradise', label: 'Ossan Paradise' },
              { value: 'p1', key: 'hash_chip_nft_species_p1', label: 'P1' },
              { value: 'planetman', key: 'hash_chip_nft_species_planetman', label: 'Planetman' },
              { value: 'signwitch', key: 'hash_chip_nft_species_signwitch', label: 'SignWitch' },
              { value: 'tofu', key: 'hash_chip_nft_species_tofu', label: 'Tofu' },
              { value: 'unicorn', key: 'hash_chip_nft_species_unicorn', label: 'Unicorn' },
              { value: 'upa', key: 'hash_chip_nft_species_upa', label: 'UPA' },
              { value: 'valius', key: 'hash_chip_nft_species_valius', label: 'Valius' },
              { value: 'yamato', key: 'hash_chip_nft_species_yamato', label: 'Yamato' },
            ],
          },
        ],
      },
      {
        value: 'each_nft_mint',
        key: 'each_nft_mint',
        label: 'Average number of mints from each NFT and $',
        children: [
          {
            value: 'average_mint_count',
            key: 'each_nft_mint_average',
            label: 'Average Mint Count',
          },
          {
            value: 'fiat',
            key: 'each_nft_mint_fiat',
            label: 'Cost (Fiat)',
          },
          {
            value: 'oas',
            key: 'each_nft_mint_oas',
            label: 'Cost (OAS)',
          },
          {
            value: 'cycle',
            key: 'each_nft_mint_cycle',
            label: 'By Mint Cycle (1回目～3回目)',
            children: [
              {
                value: 'mint_1st',
                key: 'each_nft_mint_cycle_1st',
                label: '1st Mint (1回目)',
                children: [
                  { value: 'count', key: 'each_nft_mint_cycle_1st_count', label: 'Count' },
                  { value: 'fiat', key: 'each_nft_mint_cycle_1st_fiat', label: 'Fiat' },
                  { value: 'oas', key: 'each_nft_mint_cycle_1st_oas', label: 'OAS' },
                ],
              },
              {
                value: 'mint_2nd',
                key: 'each_nft_mint_cycle_2nd',
                label: '2nd Mint (2回目)',
                children: [
                  { value: 'count', key: 'each_nft_mint_cycle_2nd_count', label: 'Count' },
                  { value: 'fiat', key: 'each_nft_mint_cycle_2nd_fiat', label: 'Fiat' },
                  { value: 'oas', key: 'each_nft_mint_cycle_2nd_oas', label: 'OAS' },
                ],
              },
              {
                value: 'mint_3rd',
                key: 'each_nft_mint_cycle_3rd',
                label: '3rd Mint (3回目)',
                children: [
                  { value: 'count', key: 'each_nft_mint_cycle_3rd_count', label: 'Count' },
                  { value: 'fiat', key: 'each_nft_mint_cycle_3rd_fiat', label: 'Fiat' },
                  { value: 'oas', key: 'each_nft_mint_cycle_3rd_oas', label: 'OAS' },
                ],
              },
              {
                value: 'mint_4th_plus',
                key: 'each_nft_mint_cycle_4th_plus',
                label: '4th+ Mint (4回目以降)',
                children: [
                  { value: 'count', key: 'each_nft_mint_cycle_4th_plus_count', label: 'Count' },
                  { value: 'fiat', key: 'each_nft_mint_cycle_4th_plus_fiat', label: 'Fiat' },
                  { value: 'oas', key: 'each_nft_mint_cycle_4th_plus_oas', label: 'OAS' },
                ],
              },
            ],
          },
          {
            value: 'species',
            key: 'each_nft_mint_species',
            label: 'By Species (使用された種類)',
            children: [
              { value: 'ame_chan', key: 'each_nft_mint_species_ame_chan', label: 'Ame-chan' },
              { value: 'astarcats', key: 'each_nft_mint_species_astarcats', label: 'AstarCats' },
              { value: 'cct', key: 'each_nft_mint_species_cct', label: 'CCT' },
              { value: 'dekausa', key: 'each_nft_mint_species_dekausa', label: 'DEKAUSA' },
              { value: 'faireaf', key: 'each_nft_mint_species_faireaf', label: 'Faireaf' },
              { value: 'golem', key: 'each_nft_mint_species_golem', label: 'Golem' },
              { value: 'hiyori', key: 'each_nft_mint_species_hiyori', label: 'Hiyori' },
              { value: 'icelime', key: 'each_nft_mint_species_icelime', label: 'Icelime' },
              { value: 'kids_hero', key: 'each_nft_mint_species_kids_hero', label: 'Kids Hero' },
              { value: 'kids_villain', key: 'each_nft_mint_species_kids_villain', label: 'Kids Villain' },
              { value: 'layla', key: 'each_nft_mint_species_layla', label: 'Layla' },
              { value: 'odenpets', key: 'each_nft_mint_species_odenpets', label: 'ODENPETS' },
              { value: 'ossan_paradise', key: 'each_nft_mint_species_ossan_paradise', label: 'Ossan Paradise' },
              { value: 'p1', key: 'each_nft_mint_species_p1', label: 'P1' },
              { value: 'planetman', key: 'each_nft_mint_species_planetman', label: 'Planetman' },
              { value: 'signwitch', key: 'each_nft_mint_species_signwitch', label: 'SignWitch' },
              { value: 'tofu', key: 'each_nft_mint_species_tofu', label: 'Tofu' },
              { value: 'unicorn', key: 'each_nft_mint_species_unicorn', label: 'Unicorn' },
              { value: 'upa', key: 'each_nft_mint_species_upa', label: 'UPA' },
              { value: 'valius', key: 'each_nft_mint_species_valius', label: 'Valius' },
              { value: 'yamato', key: 'each_nft_mint_species_yamato', label: 'Yamato' },
            ],
          },
        ],
      },
      {
        value: 'genesis_hash_mint',
        key: 'genesis_hash_mint',
        label: 'Average number of mints and $ from Genesis Hash',
        children: [
          {
            value: 'average_mint_count',
            key: 'genesis_hash_mint_average',
            label: 'Average Mint Count',
          },
          {
            value: 'fiat',
            key: 'genesis_hash_mint_fiat',
            label: 'Cost (Fiat)',
          },
          {
            value: 'oas',
            key: 'genesis_hash_mint_oas',
            label: 'Cost (OAS)',
          },
          {
            value: 'cycle',
            key: 'genesis_hash_mint_cycle',
            label: 'By Mint Cycle (1回目～5回目)',
            children: [
              {
                value: 'mint_1st',
                key: 'genesis_hash_mint_cycle_1st',
                label: '1st Mint (1回目)',
                children: [
                  { value: 'count', key: 'genesis_hash_mint_cycle_1st_count', label: 'Count' },
                  { value: 'fiat', key: 'genesis_hash_mint_cycle_1st_fiat', label: 'Fiat' },
                  { value: 'oas', key: 'genesis_hash_mint_cycle_1st_oas', label: 'OAS' },
                ],
              },
              {
                value: 'mint_2nd',
                key: 'genesis_hash_mint_cycle_2nd',
                label: '2nd Mint (2回目)',
                children: [
                  { value: 'count', key: 'genesis_hash_mint_cycle_2nd_count', label: 'Count' },
                  { value: 'fiat', key: 'genesis_hash_mint_cycle_2nd_fiat', label: 'Fiat' },
                  { value: 'oas', key: 'genesis_hash_mint_cycle_2nd_oas', label: 'OAS' },
                ],
              },
              {
                value: 'mint_3rd',
                key: 'genesis_hash_mint_cycle_3rd',
                label: '3rd Mint (3回目)',
                children: [
                  { value: 'count', key: 'genesis_hash_mint_cycle_3rd_count', label: 'Count' },
                  { value: 'fiat', key: 'genesis_hash_mint_cycle_3rd_fiat', label: 'Fiat' },
                  { value: 'oas', key: 'genesis_hash_mint_cycle_3rd_oas', label: 'OAS' },
                ],
              },
              {
                value: 'mint_4th',
                key: 'genesis_hash_mint_cycle_4th',
                label: '4th Mint (4回目)',
                children: [
                  { value: 'count', key: 'genesis_hash_mint_cycle_4th_count', label: 'Count' },
                  { value: 'fiat', key: 'genesis_hash_mint_cycle_4th_fiat', label: 'Fiat' },
                  { value: 'oas', key: 'genesis_hash_mint_cycle_4th_oas', label: 'OAS' },
                ],
              },
              {
                value: 'mint_5th',
                key: 'genesis_hash_mint_cycle_5th',
                label: '5th Mint (5回目)',
                children: [
                  { value: 'count', key: 'genesis_hash_mint_cycle_5th_count', label: 'Count' },
                  { value: 'fiat', key: 'genesis_hash_mint_cycle_5th_fiat', label: 'Fiat' },
                  { value: 'oas', key: 'genesis_hash_mint_cycle_5th_oas', label: 'OAS' },
                ],
              },
              {
                value: 'mint_6th_plus',
                key: 'genesis_hash_mint_cycle_6th_plus',
                label: '6th+ Mint (6回目以降)',
                children: [
                  { value: 'count', key: 'genesis_hash_mint_cycle_6th_plus_count', label: 'Count' },
                  { value: 'fiat', key: 'genesis_hash_mint_cycle_6th_plus_fiat', label: 'Fiat' },
                  { value: 'oas', key: 'genesis_hash_mint_cycle_6th_plus_oas', label: 'OAS' },
                ],
              },
            ],
          },
          {
            value: 'species',
            key: 'genesis_hash_mint_species',
            label: 'By Species (種類)',
            children: [
              { value: 'ame_chan', key: 'genesis_hash_mint_species_ame_chan', label: 'Ame-chan' },
              { value: 'astarcats', key: 'genesis_hash_mint_species_astarcats', label: 'AstarCats' },
              { value: 'cct', key: 'genesis_hash_mint_species_cct', label: 'CCT' },
              { value: 'dekausa', key: 'genesis_hash_mint_species_dekausa', label: 'DEKAUSA' },
              { value: 'faireaf', key: 'genesis_hash_mint_species_faireaf', label: 'Faireaf' },
              { value: 'golem', key: 'genesis_hash_mint_species_golem', label: 'Golem' },
              { value: 'hiyori', key: 'genesis_hash_mint_species_hiyori', label: 'Hiyori' },
              { value: 'icelime', key: 'genesis_hash_mint_species_icelime', label: 'Icelime' },
              { value: 'kids_hero', key: 'genesis_hash_mint_species_kids_hero', label: 'Kids Hero' },
              { value: 'kids_villain', key: 'genesis_hash_mint_species_kids_villain', label: 'Kids Villain' },
              { value: 'layla', key: 'genesis_hash_mint_species_layla', label: 'Layla' },
              { value: 'odenpets', key: 'genesis_hash_mint_species_odenpets', label: 'ODENPETS' },
              { value: 'ossan_paradise', key: 'genesis_hash_mint_species_ossan_paradise', label: 'Ossan Paradise' },
              { value: 'p1', key: 'genesis_hash_mint_species_p1', label: 'P1' },
              { value: 'planetman', key: 'genesis_hash_mint_species_planetman', label: 'Planetman' },
              { value: 'signwitch', key: 'genesis_hash_mint_species_signwitch', label: 'SignWitch' },
              { value: 'tofu', key: 'genesis_hash_mint_species_tofu', label: 'Tofu' },
              { value: 'unicorn', key: 'genesis_hash_mint_species_unicorn', label: 'Unicorn' },
              { value: 'upa', key: 'genesis_hash_mint_species_upa', label: 'UPA' },
              { value: 'valius', key: 'genesis_hash_mint_species_valius', label: 'Valius' },
              { value: 'yamato', key: 'genesis_hash_mint_species_yamato', label: 'Yamato' },
            ],
          },
        ],
      },
      {
        value: 'f_regeneration_mint',
        key: 'f_regeneration_mint',
        label: 'F Number of Mints from Regeneration',
        children: [
          {
            value: 'total',
            key: 'f_regeneration_mint_total',
            label: 'Total',
          },
          {
            value: 'average',
            key: 'f_regeneration_mint_average',
            label: 'Average',
          },
          {
            value: 'species',
            key: 'f_regeneration_mint_species',
            label: 'By Species (種類)',
            children: [
              { value: 'ame_chan', key: 'f_regeneration_mint_species_ame_chan', label: 'Ame-chan' },
              { value: 'astarcats', key: 'f_regeneration_mint_species_astarcats', label: 'AstarCats' },
              { value: 'cct', key: 'f_regeneration_mint_species_cct', label: 'CCT' },
              { value: 'dekausa', key: 'f_regeneration_mint_species_dekausa', label: 'DEKAUSA' },
              { value: 'faireaf', key: 'f_regeneration_mint_species_faireaf', label: 'Faireaf' },
              { value: 'golem', key: 'f_regeneration_mint_species_golem', label: 'Golem' },
              { value: 'hiyori', key: 'f_regeneration_mint_species_hiyori', label: 'Hiyori' },
              { value: 'icelime', key: 'f_regeneration_mint_species_icelime', label: 'Icelime' },
              { value: 'kids_hero', key: 'f_regeneration_mint_species_kids_hero', label: 'Kids Hero' },
              { value: 'kids_villain', key: 'f_regeneration_mint_species_kids_villain', label: 'Kids Villain' },
              { value: 'layla', key: 'f_regeneration_mint_species_layla', label: 'Layla' },
              { value: 'odenpets', key: 'f_regeneration_mint_species_odenpets', label: 'ODENPETS' },
              { value: 'ossan_paradise', key: 'f_regeneration_mint_species_ossan_paradise', label: 'Ossan Paradise' },
              { value: 'p1', key: 'f_regeneration_mint_species_p1', label: 'P1' },
              { value: 'planetman', key: 'f_regeneration_mint_species_planetman', label: 'Planetman' },
              { value: 'signwitch', key: 'f_regeneration_mint_species_signwitch', label: 'SignWitch' },
              { value: 'tofu', key: 'f_regeneration_mint_species_tofu', label: 'Tofu' },
              { value: 'unicorn', key: 'f_regeneration_mint_species_unicorn', label: 'Unicorn' },
              { value: 'upa', key: 'f_regeneration_mint_species_upa', label: 'UPA' },
              { value: 'valius', key: 'f_regeneration_mint_species_valius', label: 'Valius' },
              { value: 'yamato', key: 'f_regeneration_mint_species_yamato', label: 'Yamato' },
            ],
          },
        ],
      },
      {
        value: 'f_regeneration_avg_mint',
        key: 'f_regeneration_avg_mint',
        label: 'Average number of mints from F Regeneration and $',
        children: [
          {
            value: 'average_mint_count',
            key: 'f_regeneration_avg_mint_average',
            label: 'Average Mint Count',
          },
          {
            value: 'fiat',
            key: 'f_regeneration_avg_mint_fiat',
            label: 'Cost (Fiat)',
          },
          {
            value: 'oas',
            key: 'f_regeneration_avg_mint_oas',
            label: 'Cost (OAS)',
          },
          {
            value: 'cycle',
            key: 'f_regeneration_avg_mint_cycle',
            label: 'By Mint Cycle (1回目～5回目)',
            children: [
              {
                value: 'mint_1st',
                key: 'f_regeneration_avg_mint_cycle_1st',
                label: '1st Mint (1回目)',
                children: [
                  { value: 'count', key: 'f_regeneration_avg_mint_cycle_1st_count', label: 'Count' },
                  { value: 'fiat', key: 'f_regeneration_avg_mint_cycle_1st_fiat', label: 'Fiat' },
                  { value: 'oas', key: 'f_regeneration_avg_mint_cycle_1st_oas', label: 'OAS' },
                ],
              },
              {
                value: 'mint_2nd',
                key: 'f_regeneration_avg_mint_cycle_2nd',
                label: '2nd Mint (2回目)',
                children: [
                  { value: 'count', key: 'f_regeneration_avg_mint_cycle_2nd_count', label: 'Count' },
                  { value: 'fiat', key: 'f_regeneration_avg_mint_cycle_2nd_fiat', label: 'Fiat' },
                  { value: 'oas', key: 'f_regeneration_avg_mint_cycle_2nd_oas', label: 'OAS' },
                ],
              },
              {
                value: 'mint_3rd',
                key: 'f_regeneration_avg_mint_cycle_3rd',
                label: '3rd Mint (3回目)',
                children: [
                  { value: 'count', key: 'f_regeneration_avg_mint_cycle_3rd_count', label: 'Count' },
                  { value: 'fiat', key: 'f_regeneration_avg_mint_cycle_3rd_fiat', label: 'Fiat' },
                  { value: 'oas', key: 'f_regeneration_avg_mint_cycle_3rd_oas', label: 'OAS' },
                ],
              },
              {
                value: 'mint_4th',
                key: 'f_regeneration_avg_mint_cycle_4th',
                label: '4th Mint (4回目)',
                children: [
                  { value: 'count', key: 'f_regeneration_avg_mint_cycle_4th_count', label: 'Count' },
                  { value: 'fiat', key: 'f_regeneration_avg_mint_cycle_4th_fiat', label: 'Fiat' },
                  { value: 'oas', key: 'f_regeneration_avg_mint_cycle_4th_oas', label: 'OAS' },
                ],
              },
              {
                value: 'mint_5th',
                key: 'f_regeneration_avg_mint_cycle_5th',
                label: '5th Mint (5回目)',
                children: [
                  { value: 'count', key: 'f_regeneration_avg_mint_cycle_5th_count', label: 'Count' },
                  { value: 'fiat', key: 'f_regeneration_avg_mint_cycle_5th_fiat', label: 'Fiat' },
                  { value: 'oas', key: 'f_regeneration_avg_mint_cycle_5th_oas', label: 'OAS' },
                ],
              },
              {
                value: 'mint_6th_plus',
                key: 'f_regeneration_avg_mint_cycle_6th_plus',
                label: '6th+ Mint (6回目以降)',
                children: [
                  { value: 'count', key: 'f_regeneration_avg_mint_cycle_6th_plus_count', label: 'Count' },
                  { value: 'fiat', key: 'f_regeneration_avg_mint_cycle_6th_plus_fiat', label: 'Fiat' },
                  { value: 'oas', key: 'f_regeneration_avg_mint_cycle_6th_plus_oas', label: 'OAS' },
                ],
              },
            ],
          },
          {
            value: 'species',
            key: 'f_regeneration_avg_mint_species',
            label: 'By Species (種類)',
            children: [
              { value: 'ame_chan', key: 'f_regeneration_avg_mint_species_ame_chan', label: 'Ame-chan' },
              { value: 'astarcats', key: 'f_regeneration_avg_mint_species_astarcats', label: 'AstarCats' },
              { value: 'cct', key: 'f_regeneration_avg_mint_species_cct', label: 'CCT' },
              { value: 'dekausa', key: 'f_regeneration_avg_mint_species_dekausa', label: 'DEKAUSA' },
              { value: 'faireaf', key: 'f_regeneration_avg_mint_species_faireaf', label: 'Faireaf' },
              { value: 'golem', key: 'f_regeneration_avg_mint_species_golem', label: 'Golem' },
              { value: 'hiyori', key: 'f_regeneration_avg_mint_species_hiyori', label: 'Hiyori' },
              { value: 'icelime', key: 'f_regeneration_avg_mint_species_icelime', label: 'Icelime' },
              { value: 'kids_hero', key: 'f_regeneration_avg_mint_species_kids_hero', label: 'Kids Hero' },
              { value: 'kids_villain', key: 'f_regeneration_avg_mint_species_kids_villain', label: 'Kids Villain' },
              { value: 'layla', key: 'f_regeneration_avg_mint_species_layla', label: 'Layla' },
              { value: 'odenpets', key: 'f_regeneration_avg_mint_species_odenpets', label: 'ODENPETS' },
              { value: 'ossan_paradise', key: 'f_regeneration_avg_mint_species_ossan_paradise', label: 'Ossan Paradise' },
              { value: 'p1', key: 'f_regeneration_avg_mint_species_p1', label: 'P1' },
              { value: 'planetman', key: 'f_regeneration_avg_mint_species_planetman', label: 'Planetman' },
              { value: 'signwitch', key: 'f_regeneration_avg_mint_species_signwitch', label: 'SignWitch' },
              { value: 'tofu', key: 'f_regeneration_avg_mint_species_tofu', label: 'Tofu' },
              { value: 'unicorn', key: 'f_regeneration_avg_mint_species_unicorn', label: 'Unicorn' },
              { value: 'upa', key: 'f_regeneration_avg_mint_species_upa', label: 'UPA' },
              { value: 'valius', key: 'f_regeneration_avg_mint_species_valius', label: 'Valius' },
              { value: 'yamato', key: 'f_regeneration_avg_mint_species_yamato', label: 'Yamato' },
            ],
          },
        ],
      },
      {
        value: 'born_monster_types',
        key: 'born_monster_types',
        label: 'Types of Monsters that were born',
        children: [
          {
            value: 'main_seed',
            key: 'born_monster_types_main',
            label: 'By Main Seed (種族メイン - Sub Seed指定なし)',
            children: [
              { value: 'ame_chan', key: 'born_monster_types_main_ame_chan', label: 'Ame-chan' },
              { value: 'astarcats', key: 'born_monster_types_main_astarcats', label: 'AstarCats' },
              { value: 'cct', key: 'born_monster_types_main_cct', label: 'CCT' },
              { value: 'dekausa', key: 'born_monster_types_main_dekausa', label: 'DEKAUSA' },
              { value: 'faireaf', key: 'born_monster_types_main_faireaf', label: 'Faireaf' },
              { value: 'golem', key: 'born_monster_types_main_golem', label: 'Golem' },
              { value: 'hiyori', key: 'born_monster_types_main_hiyori', label: 'Hiyori' },
              { value: 'icelime', key: 'born_monster_types_main_icelime', label: 'Icelime' },
              { value: 'kids_hero', key: 'born_monster_types_main_kids_hero', label: 'Kids Hero' },
              { value: 'kids_villain', key: 'born_monster_types_main_kids_villain', label: 'Kids Villain' },
              { value: 'layla', key: 'born_monster_types_main_layla', label: 'Layla' },
              { value: 'odenpets', key: 'born_monster_types_main_odenpets', label: 'ODENPETS' },
              { value: 'ossan_paradise', key: 'born_monster_types_main_ossan_paradise', label: 'Ossan Paradise' },
              { value: 'p1', key: 'born_monster_types_main_p1', label: 'P1' },
              { value: 'planetman', key: 'born_monster_types_main_planetman', label: 'Planetman' },
              { value: 'signwitch', key: 'born_monster_types_main_signwitch', label: 'SignWitch' },
              { value: 'tofu', key: 'born_monster_types_main_tofu', label: 'Tofu' },
              { value: 'unicorn', key: 'born_monster_types_main_unicorn', label: 'Unicorn' },
              { value: 'upa', key: 'born_monster_types_main_upa', label: 'UPA' },
              { value: 'valius', key: 'born_monster_types_main_valius', label: 'Valius' },
              { value: 'yamato', key: 'born_monster_types_main_yamato', label: 'Yamato' },
            ],
          },
          {
            value: 'sub_seed',
            key: 'born_monster_types_sub',
            label: 'By Sub Seed (種族サブ)',
            children: [
              { value: 'ame_chan', key: 'born_monster_types_sub_ame_chan', label: 'Ame-chan' },
              { value: 'astarcats', key: 'born_monster_types_sub_astarcats', label: 'AstarCats' },
              { value: 'cct', key: 'born_monster_types_sub_cct', label: 'CCT' },
              { value: 'dekausa', key: 'born_monster_types_sub_dekausa', label: 'DEKAUSA' },
              { value: 'faireaf', key: 'born_monster_types_sub_faireaf', label: 'Faireaf' },
              { value: 'golem', key: 'born_monster_types_sub_golem', label: 'Golem' },
              { value: 'hiyori', key: 'born_monster_types_sub_hiyori', label: 'Hiyori' },
              { value: 'icelime', key: 'born_monster_types_sub_icelime', label: 'Icelime' },
              { value: 'kids_hero', key: 'born_monster_types_sub_kids_hero', label: 'Kids Hero' },
              { value: 'kids_villain', key: 'born_monster_types_sub_kids_villain', label: 'Kids Villain' },
              { value: 'layla', key: 'born_monster_types_sub_layla', label: 'Layla' },
              { value: 'odenpets', key: 'born_monster_types_sub_odenpets', label: 'ODENPETS' },
              { value: 'ossan_paradise', key: 'born_monster_types_sub_ossan_paradise', label: 'Ossan Paradise' },
              { value: 'p1', key: 'born_monster_types_sub_p1', label: 'P1' },
              { value: 'planetman', key: 'born_monster_types_sub_planetman', label: 'Planetman' },
              { value: 'signwitch', key: 'born_monster_types_sub_signwitch', label: 'SignWitch' },
              { value: 'tofu', key: 'born_monster_types_sub_tofu', label: 'Tofu' },
              { value: 'unicorn', key: 'born_monster_types_sub_unicorn', label: 'Unicorn' },
              { value: 'upa', key: 'born_monster_types_sub_upa', label: 'UPA' },
              { value: 'valius', key: 'born_monster_types_sub_valius', label: 'Valius' },
              { value: 'yamato', key: 'born_monster_types_sub_yamato', label: 'Yamato' },
            ],
          },
        ],
      },
    ]  
  },
  {
    value: 'fusion',
    key: 'fusion',
    label: 'Fusion',
    children: [
      {
        value: 'fusion_count',
        key: 'fusion_count',
        label: 'Fusion Count',
        children: [
          {
            value: 'total',
            key: 'fusion_count_total',
            label: 'Total',
          },
          {
            value: 'average',
            key: 'fusion_count_average',
            label: 'Average',
          },
        ],
      },
      {
        value: 'base_monster_types',
        key: 'base_monster_types',
        label: 'Base Monster Types',
        children: [
          {
            value: 'total',
            key: 'base_monster_types_total',
            label: 'Total',
          },
          {
            value: 'average',
            key: 'base_monster_types_average',
            label: 'Average',
          },
          {
            value: 'main_seed',
            key: 'base_monster_types_main',
            label: 'By Main Seed',
            children: [
              { value: 'ame_chan', key: 'base_monster_types_main_ame_chan', label: 'Ame-chan' },
              { value: 'astarcats', key: 'base_monster_types_main_astarcats', label: 'AstarCats' },
              { value: 'cct', key: 'base_monster_types_main_cct', label: 'CCT' },
              { value: 'dekausa', key: 'base_monster_types_main_dekausa', label: 'DEKAUSA' },
              { value: 'faireaf', key: 'base_monster_types_main_faireaf', label: 'Faireaf' },
              { value: 'golem', key: 'base_monster_types_main_golem', label: 'Golem' },
              { value: 'hiyori', key: 'base_monster_types_main_hiyori', label: 'Hiyori' },
              { value: 'icelime', key: 'base_monster_types_main_icelime', label: 'Icelime' },
              { value: 'kids_hero', key: 'base_monster_types_main_kids_hero', label: 'Kids Hero' },
              { value: 'kids_villain', key: 'base_monster_types_main_kids_villain', label: 'Kids Villain' },
              { value: 'layla', key: 'base_monster_types_main_layla', label: 'Layla' },
              { value: 'odenpets', key: 'base_monster_types_main_odenpets', label: 'ODENPETS' },
              { value: 'ossan_paradise', key: 'base_monster_types_main_ossan_paradise', label: 'Ossan Paradise' },
              { value: 'p1', key: 'base_monster_types_main_p1', label: 'P1' },
              { value: 'planetman', key: 'base_monster_types_main_planetman', label: 'Planetman' },
              { value: 'signwitch', key: 'base_monster_types_main_signwitch', label: 'SignWitch' },
              { value: 'tofu', key: 'base_monster_types_main_tofu', label: 'Tofu' },
              { value: 'unicorn', key: 'base_monster_types_main_unicorn', label: 'Unicorn' },
              { value: 'upa', key: 'base_monster_types_main_upa', label: 'UPA' },
              { value: 'valius', key: 'base_monster_types_main_valius', label: 'Valius' },
              { value: 'yamato', key: 'base_monster_types_main_yamato', label: 'Yamato' },
            ],
          },
          {
            value: 'sub_seed',
            key: 'base_monster_types_sub',
            label: 'By Sub Seed',
            children: [
              { value: 'ame_chan', key: 'base_monster_types_sub_ame_chan', label: 'Ame-chan' },
              { value: 'astarcats', key: 'base_monster_types_sub_astarcats', label: 'AstarCats' },
              { value: 'cct', key: 'base_monster_types_sub_cct', label: 'CCT' },
              { value: 'dekausa', key: 'base_monster_types_sub_dekausa', label: 'DEKAUSA' },
              { value: 'faireaf', key: 'base_monster_types_sub_faireaf', label: 'Faireaf' },
              { value: 'golem', key: 'base_monster_types_sub_golem', label: 'Golem' },
              { value: 'hiyori', key: 'base_monster_types_sub_hiyori', label: 'Hiyori' },
              { value: 'icelime', key: 'base_monster_types_sub_icelime', label: 'Icelime' },
              { value: 'kids_hero', key: 'base_monster_types_sub_kids_hero', label: 'Kids Hero' },
              { value: 'kids_villain', key: 'base_monster_types_sub_kids_villain', label: 'Kids Villain' },
              { value: 'layla', key: 'base_monster_types_sub_layla', label: 'Layla' },
              { value: 'odenpets', key: 'base_monster_types_sub_odenpets', label: 'ODENPETS' },
              { value: 'ossan_paradise', key: 'base_monster_types_sub_ossan_paradise', label: 'Ossan Paradise' },
              { value: 'p1', key: 'base_monster_types_sub_p1', label: 'P1' },
              { value: 'planetman', key: 'base_monster_types_sub_planetman', label: 'Planetman' },
              { value: 'signwitch', key: 'base_monster_types_sub_signwitch', label: 'SignWitch' },
              { value: 'tofu', key: 'base_monster_types_sub_tofu', label: 'Tofu' },
              { value: 'unicorn', key: 'base_monster_types_sub_unicorn', label: 'Unicorn' },
              { value: 'upa', key: 'base_monster_types_sub_upa', label: 'UPA' },
              { value: 'valius', key: 'base_monster_types_sub_valius', label: 'Valius' },
              { value: 'yamato', key: 'base_monster_types_sub_yamato', label: 'Yamato' },
            ],
          },
        ],
      },
      {
        value: 'born_monster_types',
        key: 'fusion_born_monster_types',
        label: 'Born Monster Types',
        children: [
          {
            value: 'total',
            key: 'fusion_born_monster_types_total',
            label: 'Total',
          },
          {
            value: 'main_seed',
            key: 'fusion_born_monster_types_main',
            label: 'By Main Seed',
            children: [
              { value: 'ame_chan', key: 'fusion_born_monster_types_main_ame_chan', label: 'Ame-chan' },
              { value: 'astarcats', key: 'fusion_born_monster_types_main_astarcats', label: 'AstarCats' },
              { value: 'cct', key: 'fusion_born_monster_types_main_cct', label: 'CCT' },
              { value: 'dekausa', key: 'fusion_born_monster_types_main_dekausa', label: 'DEKAUSA' },
              { value: 'faireaf', key: 'fusion_born_monster_types_main_faireaf', label: 'Faireaf' },
              { value: 'golem', key: 'fusion_born_monster_types_main_golem', label: 'Golem' },
              { value: 'hiyori', key: 'fusion_born_monster_types_main_hiyori', label: 'Hiyori' },
              { value: 'icelime', key: 'fusion_born_monster_types_main_icelime', label: 'Icelime' },
              { value: 'kids_hero', key: 'fusion_born_monster_types_main_kids_hero', label: 'Kids Hero' },
              { value: 'kids_villain', key: 'fusion_born_monster_types_main_kids_villain', label: 'Kids Villain' },
              { value: 'layla', key: 'fusion_born_monster_types_main_layla', label: 'Layla' },
              { value: 'odenpets', key: 'fusion_born_monster_types_main_odenpets', label: 'ODENPETS' },
              { value: 'ossan_paradise', key: 'fusion_born_monster_types_main_ossan_paradise', label: 'Ossan Paradise' },
              { value: 'p1', key: 'fusion_born_monster_types_main_p1', label: 'P1' },
              { value: 'planetman', key: 'fusion_born_monster_types_main_planetman', label: 'Planetman' },
              { value: 'signwitch', key: 'fusion_born_monster_types_main_signwitch', label: 'SignWitch' },
              { value: 'tofu', key: 'fusion_born_monster_types_main_tofu', label: 'Tofu' },
              { value: 'unicorn', key: 'fusion_born_monster_types_main_unicorn', label: 'Unicorn' },
              { value: 'upa', key: 'fusion_born_monster_types_main_upa', label: 'UPA' },
              { value: 'valius', key: 'fusion_born_monster_types_main_valius', label: 'Valius' },
              { value: 'yamato', key: 'fusion_born_monster_types_main_yamato', label: 'Yamato' },
            ],
          },
          {
            value: 'sub_seed',
            key: 'fusion_born_monster_types_sub',
            label: 'By Sub Seed',
            children: [
              { value: 'ame_chan', key: 'fusion_born_monster_types_sub_ame_chan', label: 'Ame-chan' },
              { value: 'astarcats', key: 'fusion_born_monster_types_sub_astarcats', label: 'AstarCats' },
              { value: 'cct', key: 'fusion_born_monster_types_sub_cct', label: 'CCT' },
              { value: 'dekausa', key: 'fusion_born_monster_types_sub_dekausa', label: 'DEKAUSA' },
              { value: 'faireaf', key: 'fusion_born_monster_types_sub_faireaf', label: 'Faireaf' },
              { value: 'golem', key: 'fusion_born_monster_types_sub_golem', label: 'Golem' },
              { value: 'hiyori', key: 'fusion_born_monster_types_sub_hiyori', label: 'Hiyori' },
              { value: 'icelime', key: 'fusion_born_monster_types_sub_icelime', label: 'Icelime' },
              { value: 'kids_hero', key: 'fusion_born_monster_types_sub_kids_hero', label: 'Kids Hero' },
              { value: 'kids_villain', key: 'fusion_born_monster_types_sub_kids_villain', label: 'Kids Villain' },
              { value: 'layla', key: 'fusion_born_monster_types_sub_layla', label: 'Layla' },
              { value: 'odenpets', key: 'fusion_born_monster_types_sub_odenpets', label: 'ODENPETS' },
              { value: 'ossan_paradise', key: 'fusion_born_monster_types_sub_ossan_paradise', label: 'Ossan Paradise' },
              { value: 'p1', key: 'fusion_born_monster_types_sub_p1', label: 'P1' },
              { value: 'planetman', key: 'fusion_born_monster_types_sub_planetman', label: 'Planetman' },
              { value: 'signwitch', key: 'fusion_born_monster_types_sub_signwitch', label: 'SignWitch' },
              { value: 'tofu', key: 'fusion_born_monster_types_sub_tofu', label: 'Tofu' },
              { value: 'unicorn', key: 'fusion_born_monster_types_sub_unicorn', label: 'Unicorn' },
              { value: 'upa', key: 'fusion_born_monster_types_sub_upa', label: 'UPA' },
              { value: 'valius', key: 'fusion_born_monster_types_sub_valius', label: 'Valius' },
              { value: 'yamato', key: 'fusion_born_monster_types_sub_yamato', label: 'Yamato' },
            ],
          },
        ],
      },
      {
        value: 'lifespan_fluctuation',
        key: 'fusion_lifespan_fluctuation',
        label: 'Average Lifespan Fluctuation',
        children: [
          {
            value: 'average_percentage',
            key: 'fusion_lifespan_fluctuation_percentage',
            label: 'Average %',
          },
        ],
      },
      {
        value: 'avg_basic_parameter',
        key: 'fusion_avg_basic_parameter',
        label: 'Average Basic Parameter',
        children: [
          { value: 'hp', key: 'fusion_avg_basic_param_hp', label: 'HP' },
          { value: 'str', key: 'fusion_avg_basic_param_str', label: 'STR' },
          { value: 'int', key: 'fusion_avg_basic_param_int', label: 'INT' },
          { value: 'dex', key: 'fusion_avg_basic_param_dex', label: 'DEX' },
          { value: 'agi', key: 'fusion_avg_basic_param_agi', label: 'AGI' },
          { value: 'vit', key: 'fusion_avg_basic_param_vit', label: 'VIT' },
        ],
      },
      {
        value: 'avg_overall_ability',
        key: 'fusion_avg_overall_ability',
        label: 'Average Overall Ability',
      },
      {
        value: 'max_overall_ability',
        key: 'fusion_max_overall_ability',
        label: 'Maximum Overall Ability',
      },
      {
        value: 'fusion_items_used',
        key: 'fusion_items_used',
        label: 'Fusion Items Used',
        children: [
          {
            value: 'total',
            key: 'fusion_items_used_total',
            label: 'Total',
          },
          {
            value: 'average',
            key: 'fusion_items_used_average',
            label: 'Average',
          },
          {
            value: 'by_type',
            key: 'fusion_items_used_by_type',
            label: 'By Item Type',
            children: [
              { value: 'crystal_total', key: 'fusion_items_used_type_crystal_total', label: 'Crystal (Total)' },
              { value: 'crystal_average', key: 'fusion_items_used_type_crystal_average', label: 'Crystal (Average)' },
              { value: 'catalyst_total', key: 'fusion_items_used_type_catalyst_total', label: 'Catalyst (Total)' },
              { value: 'catalyst_average', key: 'fusion_items_used_type_catalyst_average', label: 'Catalyst (Average)' },
              { value: 'life_potion_total', key: 'fusion_items_used_type_life_potion_total', label: 'Life Potion (Total)' },
              { value: 'life_potion_average', key: 'fusion_items_used_type_life_potion_average', label: 'Life Potion (Average)' },
            ],
          },
        ],
      },
    ],
  },
  {
    value: 'monster',
    key: 'monster',
    label: 'Monster',
    children: [
      {
        value: 'total_monster',
        key: 'total_monster',
        label: 'Total monster',
        children: [
          {
            value: 'total',
            key: 'total_monster_total',
            label: 'Total',
          },
          {
            value: 'average',
            key: 'total_monster_average',
            label: 'Average',
          },
        ],
      },
      {
        value: 'current_monster',
        key: 'current_monster',
        label: 'Current monster',
        children: [
          {
            value: 'total',
            key: 'current_monster_total',
            label: 'Total',
          },
          {
            value: 'average',
            key: 'current_monster_average',
            label: 'Average',
          },
        ],
      },
      {
        value: 'current_memory',
        key: 'current_memory',
        label: 'Current memory',
        children: [
          {
            value: 'total',
            key: 'current_memory_total',
            label: 'Total',
          },
          {
            value: 'average',
            key: 'current_memory_average',
            label: 'Average',
          },
        ],
      },
      {
        value: 'monster_training_completed',
        key: 'monster_training_completed',
        label: 'Monster training completed',
        children: [
          {
            value: 'total',
            key: 'monster_training_completed_total',
            label: 'Total',
          },
          {
            value: 'average',
            key: 'monster_training_completed_average',
            label: 'Average',
          },
          {
            value: 'percentage',
            key: 'monster_training_completed_percentage',
            label: 'Percentage',
          },
        ],
      },
      {
        value: 'used_in_rank_match',
        key: 'used_in_rank_match',
        label: 'Used in rank match',
      },
      {
        value: 'win_rank_match',
        key: 'win_rank_match',
        label: 'Win rank match',
      },
      {
        value: 'lose_rank_match',
        key: 'lose_rank_match',
        label: 'Lose rank match',
      },
      {
        value: 'used_in_tournament',
        key: 'used_in_tournament',
        label: 'Used in tournament',
      },
      {
        value: 'win_tournament',
        key: 'win_tournament',
        label: 'Win tournament',
      },
      {
        value: 'monster_rank',
        key: 'monster_rank',
        label: 'Monster rank',
        children: [
          {
            value: 'f',
            key: 'monster_rank_f',
            label: 'F',
          },
          {
            value: 'e',
            key: 'monster_rank_e',
            label: 'E',
          },
          {
            value: 'd',
            key: 'monster_rank_d',
            label: 'D',
          },
          {
            value: 'c',
            key: 'monster_rank_c',
            label: 'C',
          },
          {
            value: 'b',
            key: 'monster_rank_b',
            label: 'B',
          },
          {
            value: 'a',
            key: 'monster_rank_a',
            label: 'A',
          },
          {
            value: 's',
            key: 'monster_rank_s',
            label: 'S',
          },
        ],
      },
      {
        value: 'training_item_use',
        key: 'training_item_use',
        label: 'Training item use',
      },
      {
        value: 'average_basic_parameter',
        key: 'average_basic_parameter',
        label: 'Average basic parameter',
        children: [
          {
            value: 'hp',
            key: 'average_basic_parameter_hp',
            label: 'HP',
          },
          {
            value: 'str',
            key: 'average_basic_parameter_str',
            label: 'STR',
          },
          {
            value: 'int',
            key: 'average_basic_parameter_int',
            label: 'INT',
          },
          {
            value: 'dex',
            key: 'average_basic_parameter_dex',
            label: 'DEX',
          },
          {
            value: 'agi',
            key: 'average_basic_parameter_agi',
            label: 'AGI',
          },
          {
            value: 'vit',
            key: 'average_basic_parameter_vit',
            label: 'VIT',
          },
        ],
      },
      {
        value: 'average_overall',
        key: 'average_overall',
        label: 'Average overall',
      },
      {
        value: 'max_overall',
        key: 'max_overall',
        label: 'Maximum overall',
      },
      {
        value: 'personality',
        key: 'personality',
        label: 'Personality',
        children: [
          {
            value: 'Adventurer',
            key: 'personality_adventurer',
            label: 'Adventurer',
          },
          {
            value: 'Brave',
            key: 'personality_brave',
            label: 'Brave',
          },
          {
            value: 'Cool',
            key: 'personality_cool',
            label: 'Cool',
          },
          {
            value: 'Curious',
            key: 'personality_curious',
            label: 'Curious',
          },
          {
            value: 'Devoted',
            key: 'personality_devoted',
            label: 'Devoted',
          },
          {
            value: 'Dreamer',
            key: 'personality_dreamer',
            label: 'Dreamer',
          },
          {
            value: 'Emotional',
            key: 'personality_emotional',
            label: 'Emotional',
          },
          {
            value: 'Foodie',
            key: 'personality_foodie',
            label: 'Foodie',
          },
          {
            value: 'Gentle',
            key: 'personality_gentle',
            label: 'Gentle',
          },
          {
            value: 'Graceful',
            key: 'personality_graceful',
            label: 'Graceful',
          },
          {
            value: 'Innocent',
            key: 'personality_innocent',
            label: 'Innocent',
          },
          {
            value: 'Jolly',
            key: 'personality_jolly',
            label: 'Jolly',
          },
          {
            value: 'Lazy',
            key: 'personality_lazy',
            label: 'Lazy',
          },
          {
            value: 'Loyal',
            key: 'personality_loyal',
            label: 'Loyal',
          },
          {
            value: 'Naive',
            key: 'personality_naive',
            label: 'Naive',
          },
          {
            value: 'Optimist',
            key: 'personality_optimist',
            label: 'Optimist',
          },
          {
            value: 'Panicky',
            key: 'personality_panicky',
            label: 'Panicky',
          },
          {
            value: 'Serious',
            key: 'personality_serious',
            label: 'Serious',
          },
          {
            value: 'Shy',
            key: 'personality_shy',
            label: 'Shy',
          },
          {
            value: 'Stubborn',
            key: 'personality_stubborn',
            label: 'Stubborn',
          },
        ],
      },
      {
        value: 'innate_traits',
        key: 'innate_traits',
        label: 'Innate traits',
        children: [
          {
            value: 'Adaptability',
            key: 'innate_traits_adaptability',
            label: 'Adaptability',
          },
          {
            value: 'Agility',
            key: 'innate_traits_agility',
            label: 'Agility',
          },
          {
            value: 'Armor_Thrust',
            key: 'innate_traits_armor_thrust',
            label: 'Armor Thrust',
          },
          {
            value: 'Strike_Aptitude',
            key: 'innate_traits_strike_aptitude',
            label: 'Strike Aptitude',
          },
          {
            value: 'Strike_Mastery',
            key: 'innate_traits_strike_mastery',
            label: 'Strike Mastery',
          },
          {
            value: 'Coaching',
            key: 'innate_traits_coaching',
            label: 'Coaching',
          },
          {
            value: 'Concentration',
            key: 'innate_traits_concentration',
            label: 'Concentration',
          },
          {
            value: 'Contrarian',
            key: 'innate_traits_contrarian',
            label: 'Contrarian',
          },
          {
            value: 'Converging_Muscles',
            key: 'innate_traits_converging_muscles',
            label: 'Converging Muscles',
          },
          {
            value: 'Earth_Aptitude',
            key: 'innate_traits_earth_aptitude',
            label: 'Earth Aptitude',
          },
          {
            value: 'Earth_Mastery',
            key: 'innate_traits_earth_mastery',
            label: 'Earth Mastery',
          },
          {
            value: 'Elemental_Body',
            key: 'innate_traits_elemental_body',
            label: 'Elemental Body',
          },
          {
            value: 'Flame_Aptitude',
            key: 'innate_traits_flame_aptitude',
            label: 'Flame Aptitude',
          },
          {
            value: 'Flame_Mastery',
            key: 'innate_traits_flame_mastery',
            label: 'Flame Mastery',
          },
          {
            value: 'Flexible_Body',
            key: 'innate_traits_flexible_body',
            label: 'Flexible Body',
          },
          {
            value: 'Fountain_Of_Wisdom',
            key: 'innate_traits_fountain_of_wisdom',
            label: 'Fountain Of Wisdom',
          },
          {
            value: 'Genius',
            key: 'innate_traits_genius',
            label: 'Genius',
          },
          {
            value: 'Healing_Wave',
            key: 'innate_traits_healing_wave',
            label: 'Healing Wave',
          },
          {
            value: 'Healthy_Body',
            key: 'innate_traits_healthy_body',
            label: 'Healthy Body',
          },
          {
            value: 'Hyper_Reactivity',
            key: 'innate_traits_hyper_reactivity',
            label: 'Hyper Reactivity',
          },
          {
            value: 'Inheritance',
            key: 'innate_traits_inheritance',
            label: 'Inheritance',
          },
          {
            value: 'Insight',
            key: 'innate_traits_insight',
            label: 'Insight',
          },
          {
            value: 'Iron_heart',
            key: 'innate_traits_iron_heart',
            label: 'Iron Heart',
          },
          {
            value: 'Lightning',
            key: 'innate_traits_lightning',
            label: 'Lightning',
          },
          {
            value: 'Longevity',
            key: 'innate_traits_longevity',
            label: 'Longevity',
          },
          {
            value: 'None',
            key: 'innate_traits_none',
            label: 'None',
          },
          {
            value: 'Thrust_Mastery',
            key: 'innate_traits_thrust_mastery',
            label: 'Thrust Mastery',
          },
          {
            value: 'Slash_Mastery',
            key: 'innate_traits_slash_mastery',
            label: 'Slash Mastery',
          },
          {
            value: 'Slashing_Aptitude',
            key: 'innate_traits_slashing_aptitude',
            label: 'Slashing Aptitude',
          },
          {
            value: 'Sniper',
            key: 'innate_traits_sniper',
            label: 'Sniper',
          },
          {
            value: 'Strong_Heart',
            key: 'innate_traits_strong_heart',
            label: 'Strong Heart',
          },
          {
            value: 'Support_Master',
            key: 'innate_traits_support_master',
            label: 'Support Master',
          },
          {
            value: 'Surviver',
            key: 'innate_traits_surviver',
            label: 'Surviver',
          },
          {
            value: 'Take_a_chance',
            key: 'innate_traits_take_a_chance',
            label: 'Take a chance',
          },
          {
            value: 'Talent_for_Sleep',
            key: 'innate_traits_talent_for_sleep',
            label: 'Talent for Sleep',
          },
          {
            value: 'Thrust_Aptitude',
            key: 'innate_traits_thrust_aptitude',
            label: 'Thrust Aptitude',
          },
          {
            value: 'Treasure_Hunter',
            key: 'innate_traits_treasure_hunter',
            label: 'Treasure Hunter',
          },
          {
            value: 'Water_Aptitude',
            key: 'innate_traits_water_aptitude',
            label: 'Water Aptitude',
          },
          {
            value: 'Water_Mastery',
            key: 'innate_traits_water_mastery',
            label: 'Water Mastery',
          },
          {
            value: 'Wind_Aptitude',
            key: 'innate_traits_wind_aptitude',
            label: 'Wind Aptitude',
          },
          {
            value: 'Wind_Mastery',
            key: 'innate_traits_wind_mastery',
            label: 'Wind Mastery',
          },
        ],
      },
      {
        value: 'accquired_traits',
        key: 'accquired_traits',
        label: 'Accquired traits',
        children: [
          {
            value: 'AGI_Plus',
            key: 'accquired_traits_agi_plus',
            label: 'AGI Plus',
          },
          {
            value: 'AVD_Plus',
            key: 'accquired_traits_avd_plus',
            label: 'AVD Plus',
          },
          {
            value: 'CRI_Plus',
            key: 'accquired_traits_cri_plus',
            label: 'CRI Plus',
          },
          {
            value: 'DEX_Plus',
            key: 'accquired_traits_dex_plus',
            label: 'DEX Plus',
          },
          {
            value: 'Earth_RES_Plus',
            key: 'accquired_traits_earth_res_plus',
            label: 'Earth RES Plus',
          },
          {
            value: 'Fire_RES_Plus',
            key: 'accquired_traits_fire_res_plus',
            label: 'Fire RES Plus',
          },
          {
            value: 'HIT_Plus',
            key: 'accquired_traits_hit_plus',
            label: 'HIT Plus',
          },
          {
            value: 'HP_Plus',
            key: 'accquired_traits_hp_plus',
            label: 'HP Plus',
          },
          {
            value: 'INT_Plus',
            key: 'accquired_traits_int_plus',
            label: 'INT Plus',
          },
          {
            value: 'MND_Plus',
            key: 'accquired_traits_mnd_plus',
            label: 'MND Plus',
          },
          {
            value: 'None',
            key: 'accquired_traits_none',
            label: 'None',
          },
          {
            value: 'RES_Plus',
            key: 'accquired_traits_res_plus',
            label: 'RES Plus',
          },
          {
            value: 'Slash_RES_Plus',
            key: 'accquired_traits_slash_res_plus',
            label: 'Slash RES Plus',
          },
          {
            value: 'SPD_Plus',
            key: 'accquired_traits_spd_plus',
            label: 'SPD Plus',
          },
          {
            value: 'ST_Plus',
            key: 'accquired_traits_st_plus',
            label: 'ST Plus',
          },
          {
            value: 'STR_Plus',
            key: 'accquired_traits_str_plus',
            label: 'STR Plus',
          },
          {
            value: 'Strike_Res_Plus',
            key: 'accquired_traits_strike_res_plus',
            label: 'Strike RES Plus',
          },
          {
            value: 'Thrust_RES_Plus',
            key: 'accquired_traits_thrust_res_plus',
            label: 'Thrust RES Plus',
          },
          {
            value: 'VIT_Plus',
            key: 'accquired_traits_vit_plus',
            label: 'VIT Plus',
          },
          {
            value: 'Water_RES_Plus',
            key: 'accquired_traits_water_res_plus',
            label: 'Water RES Plus',
          },
          {
            value: 'Wind_RES_Plus',
            key: 'accquired_traits_wind_res_plus',
            label: 'Wind RES Plus',
          },
        ],
      },
      {
        value: 'average_skill_acquisition_rate',
        key: 'average_skill_acquisition_rate',
        label: 'Average skill acquisition rate',
        children: [
          {
            value: 'skill_1',
            key: 'average_skill_acquisition_rate_skill_1',
            label: 'Skill 1',
          },
          {
            value: 'skill_2',
            key: 'average_skill_acquisition_rate_skill_2',
            label: 'Skill 2',
          },
          {
            value: 'skill_3',
            key: 'average_skill_acquisition_rate_skill_3',
            label: 'Skill 3',
          },
          {
            value: 'skill_4',
            key: 'average_skill_acquisition_rate_skill_4',
            label: 'Skill 4',
          },
          {
            value: 'skill_5',
            key: 'average_skill_acquisition_rate_skill_5',
            label: 'Skill 5',
          },
          {
            value: 'skill_6',
            key: 'average_skill_acquisition_rate_skill_6',
            label: 'Skill 6',
          },
        ],
      },
      {
        value: 'skills_used_in_battle',
        key: 'skills_used_in_battle',
        label: 'Skills used in battle',
        children: [
          {
            value: 'skill_1',
            key: 'skills_used_in_battle_skill_1',
            label: 'Skill 1',
          },
          {
            value: 'skill_2',
            key: 'skills_used_in_battle_skill_2',
            label: 'Skill 2',
          },
          {
            value: 'skill_3',
            key: 'skills_used_in_battle_skill_3',
            label: 'Skill 3',
          },
          {
            value: 'skill_4',
            key: 'skills_used_in_battle_skill_4',
            label: 'Skill 4',
          },
          {
            value: 'skill_5',
            key: 'skills_used_in_battle_skill_5',
            label: 'Skill 5',
          },
          {
            value: 'skill_6',
            key: 'skills_used_in_battle_skill_6',
            label: 'Skill 6',
          },
        ],
      },
      {
        value: 'terrain',
        key: 'terrain',
        label: 'Terrain',
        children: [
          {
            value: 'main',
            key: 'terrain_main',
            label: 'Main',
            children: [
              { value: 'plains', key: 'terrain_main_plains', label: 'Plains' },
              { value: 'forest', key: 'terrain_main_forest', label: 'Forest' },
              { value: 'waterfront', key: 'terrain_main_waterfront', label: 'Waterfront' },
              { value: 'desert', key: 'terrain_main_desert', label: 'Desert' },
              { value: 'wasteland', key: 'terrain_main_wasteland', label: 'Wasteland' },
              { value: 'mountain', key: 'terrain_main_mountain', label: 'Mountain' },
              { value: 'volcano', key: 'terrain_main_volcano', label: 'Volcano' },
            ],
          },
          {
            value: 'sub',
            key: 'terrain_sub',
            label: 'Sub',
            children: [
              { value: 'plains', key: 'terrain_sub_plains', label: 'Plains' },
              { value: 'forest', key: 'terrain_sub_forest', label: 'Forest' },
              { value: 'waterfront', key: 'terrain_sub_waterfront', label: 'Waterfront' },
              { value: 'desert', key: 'terrain_sub_desert', label: 'Desert' },
              { value: 'wasteland', key: 'terrain_sub_wasteland', label: 'Wasteland' },
              { value: 'mountain', key: 'terrain_sub_mountain', label: 'Mountain' },
              { value: 'volcano', key: 'terrain_sub_volcano', label: 'Volcano' },
            ],
          },
        ],
      },
    ],
  },
  {
    value: 'crystalize',
    key: 'crystalize',
    label: 'Crystalize',
    children: [
      {
        value: 'crystalization_count',
        key: 'crystalization_count',
        label: 'Crystalization Count',
        children: [
          {
            value: 'total',
            key: 'crystalization_count_total',
            label: 'Total',
          },
          {
            value: 'average',
            key: 'crystalization_count_average',
            label: 'Average',
          },
        ],
      },
      {
        value: 'used_crystalize',
        key: 'used_crystalize',
        label: 'Used Crystalize',
        children: [
          {
            value: 'total',
            key: 'used_crystalize_total',
            label: 'Total',
          },
          {
            value: 'average',
            key: 'used_crystalize_average',
            label: 'Average',
          },
        ],
      },
      {
        value: 'crystalizeed_monster',
        key: 'crystalizeed_monster',
        label: 'Crystalizeed Monster',
      },
      {
        value: 'average_crystalize_overall',
        key: 'average_crystalize_overall',
        label: 'Average Crystalize Overall',
      },
      {
        value: 'max_crystalize_overall',
        key: 'max_crystalize_overall',
        label: 'Max Crystalize Overall',
      },
      {
        value: 'monster_rank_crystalized',
        key: 'monster_rank_crystalized',
        label: 'Monster Rank Crystalized',
        children: [
          {
            value: 'f',
            key: 'monster_rank_crystalized_f',
            label: 'F',
          },
          {
            value: 'e',
            key: 'monster_rank_crystalized_e',
            label: 'E',
          },
          {
            value: 'd',
            key: 'monster_rank_crystalized_d',
            label: 'D',
          },
          {
            value: 'c',
            key: 'monster_rank_crystalized_c',
            label: 'C',
          },
          {
            value: 'b',
            key: 'monster_rank_crystalized_b',
            label: 'B',
          },
          {
            value: 'a',
            key: 'monster_rank_crystalized_a',
            label: 'A',
          },
          {
            value: 's',
            key: 'monster_rank_crystalized_s',
            label: 'S',
          },
        ],
      },
      {
        value: 'average_basic_crystalize_parameter',
        key: 'average_basic_crystalize_parameter',
        label: 'Average Basic Crystalize Parameter',
        children: [
          {
            value: 'hp',
            key: 'average_basic_crystalize_parameter_hp',
            label: 'HP',
          },
          {
            value: 'str',
            key: 'average_basic_crystalize_parameter_str',
            label: 'STR',
          },
          {
            value: 'int',
            key: 'average_basic_crystalize_parameter_int',
            label: 'INT',
          },
          {
            value: 'dex',
            key: 'average_basic_crystalize_parameter_dex',
            label: 'DEX',
          },
          {
            value: 'agi',
            key: 'average_basic_crystalize_parameter_agi',
            label: 'AGI',
          },
          {
            value: 'vit',
            key: 'average_basic_crystalize_parameter_vit',
            label: 'VIT',
          },
        ],
      },
      {
        value: 'average_basic_crystalize_parameter_used',
        key: 'average_basic_crystalize_parameter_used',
        label: 'Average Basic Crystalize Parameter Used',
        children: [
          {
            value: 'hp',
            key: 'average_basic_crystalize_parameter_used_hp',
            label: 'HP',
          },
          {
            value: 'str',
            key: 'average_basic_crystalize_parameter_used_str',
            label: 'STR',
          },
          {
            value: 'int',
            key: 'average_basic_crystalize_parameter_used_int',
            label: 'INT',
          },
          {
            value: 'dex',
            key: 'average_basic_crystalize_parameter_used_dex',
            label: 'DEX',
          },
          {
            value: 'agi',
            key: 'average_basic_crystalize_parameter_used_agi',
            label: 'AGI',
          },
          {
            value: 'vit',
            key: 'average_basic_crystalize_parameter_used_vit',
            label: 'VIT',
          },
        ],
      },
      {
        value: 'total_crystalize_trait',
        key: 'total_crystalize_trait',
        label: 'Total Crystalize Trait',
      },
      {
        value: 'used_crystalize_trait',
        key: 'used_crystalize_trait',
        label: 'Used Crystalize Trait',
      },
    ],
  },
  {
    value: 'coach',
    key: 'coach',
    label: 'Coach',
    children: [
      {
        value: 'coach_count',
        key: 'coach_count',
        label: 'Coach Count',
        children: [
          {
            value: 'total',
            key: 'coach_count_total',
            label: 'Total',
          },
          {
            value: 'average',
            key: 'coach_count_average',
            label: 'Average',
          },
        ],
      },
      {
        value: 'coach_used',
        key: 'coach_used',
        label: 'Coach Used',
        children: [
          {
            value: 'total',
            key: 'coach_used_total',
            label: 'Total',
          },
          {
            value: 'average',
            key: 'coach_used_average',
            label: 'Average',
          },
        ],
      },
      {
        value: 'coach_monster',
        key: 'coach_monster',
        label: 'Coach Monster',
      },
      {
        value: 'average_coach_overall',
        key: 'average_coach_overall',
        label: 'Average Coach Overall',
      },
      {
        value: 'max_coach_overall',
        key: 'max_coach_overall',
        label: 'Max Coach Overall',
      },
      {
        value: 'monster_rank_coached',
        key: 'monster_rank_coached',
        label: 'Monster Rank Coached',
        children: [
          {
            value: 'f',
            key: 'monster_rank_coached_f',
            label: 'F',
          },
          {
            value: 'e',
            key: 'monster_rank_coached_e',
            label: 'E',
          },
          {
            value: 'd',
            key: 'monster_rank_coached_d',
            label: 'D',
          },
          {
            value: 'c',
            key: 'monster_rank_coached_c',
            label: 'C',
          },
          {
            value: 'b',
            key: 'monster_rank_coached_b',
            label: 'B',
          },
          {
            value: 'a',
            key: 'monster_rank_coached_a',
            label: 'A',
          },
          {
            value: 's',
            key: 'monster_rank_coached_s',
            label: 'S',
          },
        ],
      },
      {
        value: 'average_basic_coach_parameter',
        key: 'average_basic_coach_parameter',
        label: 'Average Basic Coach Parameter',
        children: [
          {
            value: 'hp',
            key: 'average_basic_coach_parameter_hp',
            label: 'HP',
          },
          {
            value: 'str',
            key: 'average_basic_coach_parameter_str',
            label: 'STR',
          },
          {
            value: 'int',
            key: 'average_basic_coach_parameter_int',
            label: 'INT',
          },
          {
            value: 'dex',
            key: 'average_basic_coach_parameter_dex',
            label: 'DEX',
          },
          {
            value: 'agi',
            key: 'average_basic_coach_parameter_agi',
            label: 'AGI',
          },
          {
            value: 'vit',
            key: 'average_basic_coach_parameter_vit',
            label: 'VIT',
          },
        ],
      },
      {
        value: 'average_basic_coach_parameter_used',
        key: 'average_basic_coach_parameter_used',
        label: 'Average Basic Coach Parameter Used',
        children: [
          {
            value: 'hp',
            key: 'average_basic_coach_parameter_used_hp',
            label: 'HP',
          },
          {
            value: 'str',
            key: 'average_basic_coach_parameter_used_str',
            label: 'STR',
          },
          {
            value: 'int',
            key: 'average_basic_coach_parameter_used_int',
            label: 'INT',
          },
          {
            value: 'dex',
            key: 'average_basic_coach_parameter_used_dex',
            label: 'DEX',
          },
          {
            value: 'agi',
            key: 'average_basic_coach_parameter_used_agi',
            label: 'AGI',
          },
          {
            value: 'vit',
            key: 'average_basic_coach_parameter_used_vit',
            label: 'VIT',
          },
        ],
      },
      {
        value: 'parameter_selected_coach',
        key: 'parameter_selected_coach',
        label: 'Parameter Selected Coach',
        children: [
          {
            value: 'hp',
            key: 'parameter_selected_coach_hp',
            label: 'HP',
          },
          {
            value: 'str',
            key: 'parameter_selected_coach_str',
            label: 'STR',
          },
          {
            value: 'int',
            key: 'parameter_selected_coach_int',
            label: 'INT',
          },
          {
            value: 'dex',
            key: 'parameter_selected_coach_dex',
            label: 'DEX',
          },
          {
            value: 'agi',
            key: 'parameter_selected_coach_agi',
            label: 'AGI',
          },
          {
            value: 'vit',
            key: 'parameter_selected_coach_vit',
            label: 'VIT',
          },
        ],
      },
      {
        value: 'parameter_used_coach',
        key: 'parameter_used_coach',
        label: 'Parameter Used Coach',
        children: [
          {
            value: 'hp',
            key: 'parameter_used_coach_hp',
            label: 'HP',
          },
          {
            value: 'str',
            key: 'parameter_used_coach_str',
            label: 'STR',
          },
          {
            value: 'int',
            key: 'parameter_used_coach_int',
            label: 'INT',
          },
          {
            value: 'dex',
            key: 'parameter_used_coach_dex',
            label: 'DEX',
          },
          {
            value: 'agi',
            key: 'parameter_used_coach_agi',
            label: 'AGI',
          },
          {
            value: 'vit',
            key: 'parameter_used_coach_vit',
            label: 'VIT',
          },
        ],
      },
    ],
  },
  {
    value: 'donate',
    key: 'donate',
    label: 'Donate',
    children: [
      {
        value: 'donated_monster_count',
        key: 'donated_monster_count',
        label: 'Number of Monsters Donated',
        children: [
          {
            value: 'total',
            key: 'donated_monster_count_total',
            label: 'Total',
          },
          {
            value: 'average',
            key: 'donated_monster_count_average',
            label: 'Average',
          },
        ],
      },
      {
        value: 'ma_point_earned',
        key: 'ma_point_earned',
        label: 'Number of MA Points issued',
        children: [
          {
            value: 'total',
            key: 'ma_point_earned_total',
            label: 'Total',
          },
          {
            value: 'average',
            key: 'ma_point_earned_average',
            label: 'Average',
          },
        ],
      },
      {
        value: 'donated_monster',
        key: 'donated_monster',
        label: 'Donated Monster',
      },
      {
        value: 'average_donated_overall_ability',
        key: 'average_donated_overall_ability',
        label: 'Average Overall Ability at the time of donation',
      },
      {
        value: 'max_donated_overall_ability',
        key: 'max_donated_overall_ability',
        label: 'Maximum Overall Ability at the time of Donation',
      },
      {
        value: 'monster_rank_donated',
        key: 'monster_rank_donated',
        label: 'Monster Rank at the time of Donation',
        children: [
          {
            value: 'f',
            key: 'monster_rank_donated_f',
            label: 'F',
          },
          {
            value: 'e',
            key: 'monster_rank_donated_e',
            label: 'E',
          },
          {
            value: 'd',
            key: 'monster_rank_donated_d',
            label: 'D',
          },
          {
            value: 'c',
            key: 'monster_rank_donated_c',
            label: 'C',
          },
          {
            value: 'b',
            key: 'monster_rank_donated_b',
            label: 'B',
          },
          {
            value: 'a',
            key: 'monster_rank_donated_a',
            label: 'A',
          },
          {
            value: 's',
            key: 'monster_rank_donated_s',
            label: 'S',
          },
        ],
      },
    ],
  },
  {
    value: 'farm',
    key: 'farmNFT',
    label: 'Farm NFT',
    children: [
      {
        value: 'number_of_farm',
        key: 'number_of_farm',
        label: 'Number Of Farm',
        children: [
          {
            value: 'total',
            key: 'number_of_farm_total',
            label: 'Total',
          },
          {
            value: 'average',
            key: 'number_of_farm_average',
            label: 'Average',
          },
        ],
      },
      {
        value: 'farm_parameters',
        key: 'farm_parameters',
        label: 'Various Parameters of Farm when Minted',
        children: [
          {
            value: 'farm_basic_enhance_value',
            key: 'farm_basic_enhance_value',
            label: 'Farm Basic Enhance Value',
            children: [
              {
                value: 'health',
                key: 'farm_basic_enhance_value_health',
                label: 'Health',
              },
              {
                value: 'strength',
                key: 'farm_basic_enhance_value_strength',
                label: 'Strength',
              },
              {
                value: 'intelligent',
                key: 'farm_basic_enhance_value_intelligent',
                label: 'Intelligent',
              },
              {
                value: 'dexterity',
                key: 'farm_basic_enhance_value_dexterity',
                label: 'Dexterity',
              },
              {
                value: 'agility',
                key: 'farm_basic_enhance_value_agility',
                label: 'Agility',
              },
              {
                value: 'vitality',
                key: 'farm_basic_enhance_value_vitality',
                label: 'Vitality',
              },
            ],
          },
          {
            value: 'farm_stress_enhance_value',
            key: 'farm_stress_enhance_value',
            label: 'Farm Stress Enhance Value',
          },
          {
            value: 'farm_fatigue_enhance_value',
            key: 'farm_fatigue_enhance_value',
            label: 'Farm Fatigue Enhance Value',
          },
          {
            value: 'farm_rest_enhance_value',
            key: 'farm_rest_enhance_value',
            label: 'Farm Rest Enhance Value',
          },
        ],
      },
      {
        value: 'farm_suitability',
        key: 'farm_suitability',
        label: 'Farm Suitability',
        children: [
          {
            value: 'health',
            key: 'farm_suitability_health',
            label: 'Health',
            children: [
              { value: 's', key: 'farm_suitability_health_s', label: 'Rank S' },
              { value: 'a', key: 'farm_suitability_health_a', label: 'Rank A' },
              { value: 'b', key: 'farm_suitability_health_b', label: 'Rank B' },
              { value: 'c', key: 'farm_suitability_health_c', label: 'Rank C' },
              { value: 'd', key: 'farm_suitability_health_d', label: 'Rank D' },
              { value: 'e', key: 'farm_suitability_health_e', label: 'Rank E' },
              { value: 'f', key: 'farm_suitability_health_f', label: 'Rank F' },
            ],
          },
          {
            value: 'strength',
            key: 'farm_suitability_strength',
            label: 'Strength',
            children: [
              { value: 's', key: 'farm_suitability_strength_s', label: 'Rank S' },
              { value: 'a', key: 'farm_suitability_strength_a', label: 'Rank A' },
              { value: 'b', key: 'farm_suitability_strength_b', label: 'Rank B' },
              { value: 'c', key: 'farm_suitability_strength_c', label: 'Rank C' },
              { value: 'd', key: 'farm_suitability_strength_d', label: 'Rank D' },
              { value: 'e', key: 'farm_suitability_strength_e', label: 'Rank E' },
              { value: 'f', key: 'farm_suitability_strength_f', label: 'Rank F' },
            ],
          },
          {
            value: 'intelligent',
            key: 'farm_suitability_intelligent',
            label: 'Intelligent',
            children: [
              { value: 's', key: 'farm_suitability_intelligent_s', label: 'Rank S' },
              { value: 'a', key: 'farm_suitability_intelligent_a', label: 'Rank A' },
              { value: 'b', key: 'farm_suitability_intelligent_b', label: 'Rank B' },
              { value: 'c', key: 'farm_suitability_intelligent_c', label: 'Rank C' },
              { value: 'd', key: 'farm_suitability_intelligent_d', label: 'Rank D' },
              { value: 'e', key: 'farm_suitability_intelligent_e', label: 'Rank E' },
              { value: 'f', key: 'farm_suitability_intelligent_f', label: 'Rank F' },
            ],
          },
          {
            value: 'dexterity',
            key: 'farm_suitability_dexterity',
            label: 'Dexterity',
            children: [
              { value: 's', key: 'farm_suitability_dexterity_s', label: 'Rank S' },
              { value: 'a', key: 'farm_suitability_dexterity_a', label: 'Rank A' },
              { value: 'b', key: 'farm_suitability_dexterity_b', label: 'Rank B' },
              { value: 'c', key: 'farm_suitability_dexterity_c', label: 'Rank C' },
              { value: 'd', key: 'farm_suitability_dexterity_d', label: 'Rank D' },
              { value: 'e', key: 'farm_suitability_dexterity_e', label: 'Rank E' },
              { value: 'f', key: 'farm_suitability_dexterity_f', label: 'Rank F' },
            ],
          },
          {
            value: 'agility',
            key: 'farm_suitability_agility',
            label: 'Agility',
            children: [
              { value: 's', key: 'farm_suitability_agility_s', label: 'Rank S' },
              { value: 'a', key: 'farm_suitability_agility_a', label: 'Rank A' },
              { value: 'b', key: 'farm_suitability_agility_b', label: 'Rank B' },
              { value: 'c', key: 'farm_suitability_agility_c', label: 'Rank C' },
              { value: 'd', key: 'farm_suitability_agility_d', label: 'Rank D' },
              { value: 'e', key: 'farm_suitability_agility_e', label: 'Rank E' },
              { value: 'f', key: 'farm_suitability_agility_f', label: 'Rank F' },
            ],
          },
          {
            value: 'vitality',
            key: 'farm_suitability_vitality',
            label: 'Vitality',
            children: [
              { value: 's', key: 'farm_suitability_vitality_s', label: 'Rank S' },
              { value: 'a', key: 'farm_suitability_vitality_a', label: 'Rank A' },
              { value: 'b', key: 'farm_suitability_vitality_b', label: 'Rank B' },
              { value: 'c', key: 'farm_suitability_vitality_c', label: 'Rank C' },
              { value: 'd', key: 'farm_suitability_vitality_d', label: 'Rank D' },
              { value: 'e', key: 'farm_suitability_vitality_e', label: 'Rank E' },
              { value: 'f', key: 'farm_suitability_vitality_f', label: 'Rank F' },
            ],
          },
          {
            value: 'stress',
            key: 'farm_suitability_stress',
            label: 'Stress',
            children: [
              { value: 's', key: 'farm_suitability_stress_s', label: 'Rank S' },
              { value: 'a', key: 'farm_suitability_stress_a', label: 'Rank A' },
              { value: 'b', key: 'farm_suitability_stress_b', label: 'Rank B' },
              { value: 'c', key: 'farm_suitability_stress_c', label: 'Rank C' },
              { value: 'd', key: 'farm_suitability_stress_d', label: 'Rank D' },
              { value: 'e', key: 'farm_suitability_stress_e', label: 'Rank E' },
              { value: 'f', key: 'farm_suitability_stress_f', label: 'Rank F' },
            ],
          },
          {
            value: 'fatigue',
            key: 'farm_suitability_fatigue',
            label: 'Fatigue',
            children: [
              { value: 's', key: 'farm_suitability_fatigue_s', label: 'Rank S' },
              { value: 'a', key: 'farm_suitability_fatigue_a', label: 'Rank A' },
              { value: 'b', key: 'farm_suitability_fatigue_b', label: 'Rank B' },
              { value: 'c', key: 'farm_suitability_fatigue_c', label: 'Rank C' },
              { value: 'd', key: 'farm_suitability_fatigue_d', label: 'Rank D' },
              { value: 'e', key: 'farm_suitability_fatigue_e', label: 'Rank E' },
              { value: 'f', key: 'farm_suitability_fatigue_f', label: 'Rank F' },
            ],
          },
          {
            value: 'rest',
            key: 'farm_suitability_rest',
            label: 'Rest',
            children: [
              { value: 's', key: 'farm_suitability_rest_s', label: 'Rank S' },
              { value: 'a', key: 'farm_suitability_rest_a', label: 'Rank A' },
              { value: 'b', key: 'farm_suitability_rest_b', label: 'Rank B' },
              { value: 'c', key: 'farm_suitability_rest_c', label: 'Rank C' },
              { value: 'd', key: 'farm_suitability_rest_d', label: 'Rank D' },
              { value: 'e', key: 'farm_suitability_rest_e', label: 'Rank E' },
              { value: 'f', key: 'farm_suitability_rest_f', label: 'Rank F' },
            ],
          },
        ],
      },
      {
        value: 'special_training_value',
        key: 'special_training_value',
        label: 'Special Training Value',
        children: [
          {
            value: 'main',
            key: 'special_training_value_main',
            label: 'Main (+12)',
            children: [
              {
                value: 'health',
                key: 'special_training_value_main_health',
                label: 'Health',
              },
              {
                value: 'strength',
                key: 'special_training_value_main_strength',
                label: 'Strength',
              },
              {
                value: 'intelligent',
                key: 'special_training_value_main_intelligent',
                label: 'Intelligent',
              },
              {
                value: 'dexterity',
                key: 'special_training_value_main_dexterity',
                label: 'Dexterity',
              },
              {
                value: 'agility',
                key: 'special_training_value_main_agility',
                label: 'Agility',
              },
              {
                value: 'vitality',
                key: 'special_training_value_main_vitality',
                label: 'Vitality',
              },
            ],
          },
          {
            value: 'sub',
            key: 'special_training_value_sub',
            label: 'Sub (+6)',
            children: [
              {
                value: 'health',
                key: 'special_training_value_sub_health',
                label: 'Health',
              },
              {
                value: 'strength',
                key: 'special_training_value_sub_strength',
                label: 'Strength',
              },
              {
                value: 'intelligent',
                key: 'special_training_value_sub_intelligent',
                label: 'Intelligent',
              },
              {
                value: 'dexterity',
                key: 'special_training_value_sub_dexterity',
                label: 'Dexterity',
              },
              {
                value: 'agility',
                key: 'special_training_value_sub_agility',
                label: 'Agility',
              },
              {
                value: 'vitality',
                key: 'special_training_value_sub_vitality',
                label: 'Vitality',
              },
            ],
          },
          {
            value: 'decrease',
            key: 'special_training_value_decrease',
            label: 'Decrease (-6)',
            children: [
              {
                value: 'health',
                key: 'special_training_value_decrease_health',
                label: 'Health',
              },
              {
                value: 'strength',
                key: 'special_training_value_decrease_strength',
                label: 'Strength',
              },
              {
                value: 'intelligent',
                key: 'special_training_value_decrease_intelligent',
                label: 'Intelligent',
              },
              {
                value: 'dexterity',
                key: 'special_training_value_decrease_dexterity',
                label: 'Dexterity',
              },
              {
                value: 'agility',
                key: 'special_training_value_decrease_agility',
                label: 'Agility',
              },
              {
                value: 'vitality',
                key: 'special_training_value_decrease_vitality',
                label: 'Vitality',
              },
            ],
          },
        ],
      },
      {
        value: 'farm_enhancement_item',
        key: 'farm_enhancement_item',
        label: 'Number of Enhancement Items Used in Farm',
        children: [
          {
            value: 'total',
            key: 'farm_enhancement_item_total',
            label: 'Total',
          },
          {
            value: 'boots',
            key: 'farm_boots_item_used',
            label: 'Farm Boots Item',
          },
          {
            value: 'accuracy_guide_book',
            key: 'farm_enhancement_item_accuracy_guide_book',
            label: 'Accuracy Guide Book',
          },
          {
            value: 'avoidance_guide_book',
            key: 'farm_enhancement_item_avoidance_guide_book',
            label: 'Avoidance Guide Book',
          },
          {
            value: 'defense_guide_book',
            key: 'farm_enhancement_item_defense_guide_book',
            label: 'Defense Guide Book',
          },
          {
            value: 'stamina_guide_book',
            key: 'farm_enhancement_item_stamina_guide_book',
            label: 'Stamina Guide Book',
          },
          {
            value: 'strength_guide_book',
            key: 'farm_enhancement_item_strength_guide_book',
            label: 'Strength Guide Book',
          },
          {
            value: 'wisdom_guide_book',
            key: 'farm_enhancement_item_wisdom_guide_book',
            label: 'Wisdom Guide Book',
          },
          {
            value: 'incense_burner',
            key: 'farm_enhancement_item_incense_burner',
            label: 'Incense Burner',
          },
          {
            value: 'pitcher_of_prayer',
            key: 'farm_enhancement_item_pitcher_of_prayer',
            label: 'Pitcher of Prayer',
          },
          {
            value: 'premium_aroma',
            key: 'farm_enhancement_item_premium_aroma',
            label: 'Premium Aroma',
          },
        ],
      },
      {
        value: 'farm_average_parameter',
        key: 'farm_average_parameter',
        label: 'Farm Average Parameter',
        children: [
          {
            value: 'farm_average_overall',
            key: 'farm_average_overall',
            label: 'Average Overall',
          },
        ],
      },
      {
        value: 'farm_trait_id',
        key: 'farm_trait',
        label: 'Farm Trait',
        children: [
          {
            value: 'total',
            key: 'farm_trait_id_total',
            label: 'Total',
          },
          {
            value: 'None',
            key: 'farm_trait_id_none',
            label: 'None',
          },
          {
            value: 'AGI_Plus',
            key: 'farm_trait_id_agi_plus',
            label: 'AGI Plus',
          },
          {
            value: 'AVD_Plus',
            key: 'farm_trait_id_avd_plus',
            label: 'AVD Plus',
          },
          {
            value: 'Strike_RES_Plus',
            key: 'farm_trait_id_strike_res_plus',
            label: 'Strike RES Plus',
          },
          {
            value: 'CRI_Plus',
            key: 'farm_trait_id_cri_plus',
            label: 'CRI Plus',
          },
          {
            value: 'DEX_Plus',
            key: 'farm_trait_id_dex_plus',
            label: 'DEX Plus',
          },
          {
            value: 'Earth_RES_Plus',
            key: 'farm_trait_id_earth_res_plus',
            label: 'Earth RES Plus',
          },
          {
            value: 'Fire_RES_Plus',
            key: 'farm_trait_id_fire_res_plus',
            label: 'Fire RES Plus',
          },
          {
            value: 'HIT_Plus',
            key: 'farm_trait_id_hit_plus',
            label: 'HIT Plus',
          },
          {
            value: 'HP_Plus',
            key: 'farm_trait_id_hp_plus',
            label: 'HP Plus',
          },
          {
            value: 'INT_Plus',
            key: 'farm_trait_id_int_plus',
            label: 'INT Plus',
          },
          {
            value: 'MND_Plus',
            key: 'farm_trait_id_mnd_plus',
            label: 'MND Plus',
          },
          {
            value: 'RES_Plus',
            key: 'farm_trait_id_res_plus',
            label: 'RES Plus',
          },
          {
            value: 'Slash_RES_Plus',
            key: 'farm_trait_id_slash_res_plus',
            label: 'Slash RES Plus',
          },
          {
            value: 'SPD_Plus',
            key: 'farm_trait_id_spd_plus',
            label: 'SPD Plus',
          },
          {
            value: 'ST_Plus',
            key: 'farm_trait_id_st_plus',
            label: 'ST Plus',
          },
          {
            value: 'STR_Plus',
            key: 'farm_trait_id_str_plus',
            label: 'STR Plus',
          },
          {
            value: 'Thrust_RES_Plus',
            key: 'farm_trait_id_thrust_res_plus',
            label: 'Thrust RES Plus',
          },
          {
            value: 'VIT_Plus',
            key: 'farm_trait_id_vit_plus',
            label: 'VIT Plus',
          },
          {
            value: 'Water_RES_Plus',
            key: 'farm_trait_id_water_res_plus',
            label: 'Water RES Plus',
          },
          {
            value: 'Wind_RES_Plus',
            key: 'farm_trait_id_wind_res_plus',
            label: 'Wind RES Plus',
          },
        ],
      },
    ],
  },
  {
    value: 'item',
    key: 'item',
    label: 'Item',
    children: [
      {
        value: 'item_mint_count',
        key: 'item_mint_count',
        label: 'Item Mint Count',
      },
      {
        value: 'item_used_count',
        key: 'item_used_count',
        label: 'Item Used Count',
      },
      {
        value: 'item_distribution',
        key: 'item_distribution',
        label: 'Item Distribution',
      },
      {
        value: 'item_acquisition',
        key: 'item_acquisition',
        label: 'Item Acquisition',
        children: [
          {
            value: 'total',
            key: 'item_acquisition_total',
            label: 'Total',
          },
          {
            value: 'tournament',
            key: 'item_acquisition_tournament',
            label: 'Tournament',
          },
          {
            value: 'exploration',
            key: 'item_acquisition_exploration',
            label: 'Exploration',
          },
          {
            value: 'prize_rank_match',
            key: 'item_acquisition_prize_rank_match',
            label: 'Prize Rank Match',
          },
          {
            value: 'shop',
            key: 'item_acquisition_shop',
            label: 'Shop',
          },
          {
            value: 'login_bonus',
            key: 'item_acquisition_login_bonus',
            label: 'Login Bonus',
          },
          {
            value: 'other',
            key: 'item_acquisition_other',
            label: 'Other',
          },
        ],
      },
    ],
  },
]
export const getLevelKeys = (items1) => {
  const key = {}
  const func = (items2, level = 1) => {
    items2.forEach((item) => {
      if (item.key) {
        key[item.key] = level
      }
      if (item.children) {
        func(item.children, level + 1)
      }
    })
  }
  func(items1)
  return key
}
export const levelKeys = getLevelKeys(itemsGameDashboard)
export const nameSector = (name) => {
  switch (name) {
    case 1:
      return 'Algo-Roots'
    case 2:
      return 'Echo-Leaves'
    case 3:
      return 'Bi-Flowers'
    default:
  }
}

export const StateSponsorTournament = (name) => {
  switch (name) {
    case 0:
      return 'Upcoming'
    case 1:
      return 'Registration'
    case 2:
      return 'Entry'
    case 3:
      return 'JumpIn'
    case 4:
      return 'InProgress'
    case 5:
      return 'Ended'
    default:
  }
}

export const getRankbyValue = (rank) => {
  switch (rank) {
    case 7:
      return 'SP'
    case 6:
      return 'S'
    case 5:
      return 'A'
    case 4:
      return 'B'
    case 3:
      return 'C'
    case 2:
      return 'D'
    case 1:
      return 'E'
    case 0:
      return 'F'
    default:
      return 'F'
  }
}

export const dataGuildLevel = (level) => {
  const levels = {
    1: { requiredEXP: 0, maxMembers: 10, submasterLimit: 1, optionalRoles: 2 },
    2: {
      requiredEXP: 2000,
      maxMembers: 12,
      submasterLimit: 1,
      optionalRoles: 2,
    },
    3: {
      requiredEXP: 2980,
      maxMembers: 14,
      submasterLimit: 1,
      optionalRoles: 2,
    },
    4: {
      requiredEXP: 4100,
      maxMembers: 16,
      submasterLimit: 1,
      optionalRoles: 2,
    },
    5: {
      requiredEXP: 5360,
      maxMembers: 18,
      submasterLimit: 1,
      optionalRoles: 3,
    },
    6: {
      requiredEXP: 6760,
      maxMembers: 20,
      submasterLimit: 2,
      optionalRoles: 3,
    },
    7: {
      requiredEXP: 8300,
      maxMembers: 22,
      submasterLimit: 2,
      optionalRoles: 3,
    },
    8: {
      requiredEXP: 9980,
      maxMembers: 24,
      submasterLimit: 2,
      optionalRoles: 3,
    },
    9: {
      requiredEXP: 11800,
      maxMembers: 26,
      submasterLimit: 2,
      optionalRoles: 4,
    },
    10: {
      requiredEXP: 13760,
      maxMembers: 28,
      submasterLimit: 2,
      optionalRoles: 4,
    },
    11: {
      requiredEXP: 15860,
      maxMembers: 30,
      submasterLimit: 3,
      optionalRoles: 4,
    },
    12: {
      requiredEXP: 18100,
      maxMembers: 32,
      submasterLimit: 3,
      optionalRoles: 4,
    },
    13: {
      requiredEXP: 20480,
      maxMembers: 34,
      submasterLimit: 3,
      optionalRoles: 5,
    },
    14: {
      requiredEXP: 23000,
      maxMembers: 36,
      submasterLimit: 3,
      optionalRoles: 5,
    },
    15: {
      requiredEXP: 25660,
      maxMembers: 38,
      submasterLimit: 3,
      optionalRoles: 5,
    },
    16: {
      requiredEXP: 28460,
      maxMembers: 40,
      submasterLimit: 3,
      optionalRoles: 5,
    },
    17: {
      requiredEXP: 31400,
      maxMembers: 42,
      submasterLimit: 3,
      optionalRoles: 6,
    },
    18: {
      requiredEXP: 34480,
      maxMembers: 44,
      submasterLimit: 3,
      optionalRoles: 6,
    },
    19: {
      requiredEXP: 37700,
      maxMembers: 46,
      submasterLimit: 3,
      optionalRoles: 6,
    },
    20: {
      requiredEXP: 41060,
      maxMembers: 48,
      submasterLimit: 3,
      optionalRoles: 6,
    },
  }

  return levels[level] || {}
}
export const convertImageMonsterSeed = (image) => {
  switch (image) {
    case 'Ame_chan_Ame_chan_1':
      return 'Amechan_1_InGame'
    case 'Ame_chan_Golem_1':
      return 'Amechan [Powered]_InGame'
    case 'Ame_chan_Hiyori_1':
      return 'Amechan [Wafuku]_InGame'
    case 'Ame_chan_Icelime_1':
      return 'Amechan [Summer]_InGame'
    case 'Ame_chan_Kids_Villain_1':
      return 'Amechan [Villain]_InGame'
    case 'Ame_chan_Layla_1':
      return 'Amechan [Imp]_InGame'
    case 'Ame_chan_Yamato_1':
      return 'Amechan [School]_InGame'
    case 'AstarCats_AstarCats_1':
      return 'AstarCat_1_InGame'
    case 'AstarCats_Faireaf_1':
      return 'AstarCat_FairyCat_InGame'
    case 'AstarCats_Hiyori_1':
      return 'AstarCat_WafukuCat_InGame'
    case 'AstarCats_Kids_Villain_1':
      return 'AstarCat_VillainCat_InGame'
    case 'AstarCats_Ossan_Paradise_1':
      return 'AstarCat_MaskCat_InGame'
    case 'AstarCats_SignWitch_1':
      return 'AstarCat_WitchCat_InGame'
    case 'AstarCats_Tofu_1':
      return 'AstarCat_TofuCat_InGame'
    case 'CCT_CCT_1':
      return 'CCT_Coni_InGame'
    case 'CCT_CCT_2':
      return 'CCT_Mous_InGame'
    case 'CCT_CCT_3':
      return 'CCT_Bot_InGame'
    case 'CCT_CCT_4':
      return 'CCT_Conic_InGame'
    case 'DEKAUSA_CCT_1':
      return 'Dekausa_DEKACONI_InGame'
    case 'DEKAUSA_DEKAUSA_1':
      return 'Dekausa_1_InGame'
    case 'DEKAUSA_Golem_1':
      return 'Dekausa_GOLIATH_InGame'
    case 'DEKAUSA_ODENPETS_1':
      return 'Dekausa_DEKALABY_InGame'
    case 'DEKAUSA_Planetman_1':
      return 'Dekausa_TARU-USA_InGame'
    case 'DEKAUSA_Tofu_1':
      return 'Dekausa_SOY_InGame'
    case 'DEKAUSA_Yamato_1':
      return 'Dekausa_BANCHO_InGame'
    case 'Faireaf_Ame_chan_1':
      return 'Faireaf_Cantis_InGame'
    case 'Faireaf_Faireaf_1':
      return 'Faireaf_1_InGame'
    case 'Faireaf_Layla_1':
      return 'Faireaf_Lilim_InGame'
    case 'Faireaf_P1_1':
      return 'Faireaf_Caliy_InGame'
    case 'Faireaf_SignWitch_1':
      return 'Faireaf_Aether_InGame'
    case 'Faireaf_Tofu_1':
      return 'Faireaf_Whisper_InGame'
    case 'Faireaf_Valius_1':
      return 'Faireaf_Wolfair_InGame'
    case 'Golem_DEKAUSA_1':
      return 'Rabilen_1_InGame'
    case 'Golem_Golem_1':
      return 'Golem_1_InGame'
    case 'Golem_Kids_Hero_1':
      return 'Patrolem_1_InGame'
    case 'Golem_Kids_Villain_1':
      return 'Pazuzu_1_InGame'
    case 'Golem_Ossan_Paradise_1':
      return 'Quackle_1_InGame'
    case 'Golem_Planetman_1':
      return 'Wooden_1_InGame'
    case 'Golem_UPA_1':
      return 'Looper_1_InGame'
    case 'Hiyori_Ame_chan_1':
      return 'Hiyori_Nanami_InGame'
    case 'Hiyori_Faireaf_1':
      return 'Hiyori_Mei_InGame'
    case 'Hiyori_Hiyori_1':
      return 'Hiyori_1_InGame'
    case 'Hiyori_Icelime_1':
      return 'Hiyori_Yui_InGame'
    case 'Hiyori_Layla_1':
      return 'Hiyori_Ayano_InGame'
    case 'Hiyori_Unicorn_1':
      return 'Hiyori_Orika_InGame'
    case 'Hiyori_Valius_1':
      return 'Hiyori_Akane_InGame'
    case 'Icelime_CCT_1':
      return 'icelime_conintown_InGame'
    case 'Icelime_DEKAUSA_1':
      return 'icelime_dekausa_InGame'
    case 'Icelime_Icelime_1':
      return 'IceLime_Eien_InGame'
    case 'Icelime_Kids_Hero_1':
      return 'icelime_kidhero_InGame'
    case 'Icelime_Unicorn_1':
      return 'icelime_unicorn_InGame'
    case 'Icelime_UPA_1':
      return 'icelime_UPA_InGame'
    case 'Icelime_Yamato_1':
      return 'icelime_yamato_InGame'
    case 'Kids_Hero_Kids_Hero_1':
      return 'Kidsfight_KidsHero_1_InGame'
    case 'Kids_Hero_Kids_Hero_2':
      return 'Kidsfight_KidsHero_2_InGame'
    case 'Kids_Hero_Kids_Hero_3':
      return 'Kidsfight_KidsHero_3_InGame'
    case 'Kids_Hero_Kids_Hero_4':
      return 'Kidsfight_KidsHero_4_InGame'
    case 'Kids_Hero_Kids_Hero_5':
      return 'Kidsfight_KidsHero_5_InGame'
    case 'Kids_Villain_Kids_Villain_1':
      return 'Kidsfight_KidsVillian_1_InGame'
    case 'Kids_Villain_Kids_Villain_2':
      return 'Kidsfight_KidsVillian_2_InGame'
    case 'Kids_Villain_Kids_Villain_3':
      return 'Kidsfight_KidsVillian_3_InGame'
    case 'Kids_Villain_Kids_Villain_4':
      return 'Kidsfight_KidsVillian_4_InGame'
    case 'Kids_Villain_Kids_Villain_5':
      return 'Kidsfight_KidsVillian_5_InGame'
    case 'Layla_Faireaf_1':
      return 'Layla_Bella_InGame'
    case 'Layla_Hiyori_1':
      return 'Layla_Matoi_InGame'
    case 'Layla_Icelime_1':
      return 'Layla_Sora_InGame'
    case 'Layla_Layla_1':
      return 'Layla_1_InGame'
    case 'Layla_P1_1':
      return 'Layla_Eve_InGame'
    case 'Layla_SignWitch_1':
      return 'Layla_Olivia_InGame'
    case 'Layla_Valius_1':
      return 'Layla_Luna_InGame'
    case 'ODENPETS_Ame_chan_1':
      return 'ODENPETS_Kumatama_InGame'
    case 'ODENPETS_DEKAUSA_1':
      return 'ODENPETS_Laby_InGame'
    case 'ODENPETS_Kids_Hero_1':
      return 'ODENPETS_Monta_InGame'
    case 'ODENPETS_ODENPETS_1':
      return 'ODENPETS_Pochi_InGame'
    case 'ODENPETS_P1_1':
      return 'ODENPETS_Nyanpen_InGame'
    case 'Ossan_Paradise_Ossan_Paradise_1':
      return 'OssanParadise_1_InGame'
    case 'Ossan_Paradise_Ossan_Paradise_2':
      return 'OssanParadise_2_InGame'
    case 'Ossan_Paradise_Ossan_Paradise_3':
      return 'OssanParadise_3_InGame'
    case 'Ossan_Paradise_Ossan_Paradise_4':
      return 'OssanParadise_4_InGame'
    case 'Ossan_Paradise_Ossan_Paradise_5':
      return 'OssanParadise_5_InGame'
    case 'P1_Faireaf_1':
      return 'F2_InGame'
    case 'P1_Hiyori_1':
      return 'J8_InGame'
    case 'P1_Icelime_1':
      return 'I12_InGame'
    case 'P1_Kids_Hero_1':
      return 'H17_InGame'
    case 'P1_Layla_1':
      return 'G20_InGame'
    case 'P1_P1_1':
      return 'P1_XSoldier_InGame'
    case 'P1_SignWitch_1':
      return 'W3_InGame'
    case 'Planetman_AstarCats_1':
      return 'planetman_astarcat_InGame'
    case 'Planetman_CCT_1':
      return 'planetman_conintown_InGame'
    case 'Planetman_Golem_1':
      return 'planetman_golem_InGame'
    case 'Planetman_Kids_Hero_1':
      return 'planetman_kidhero_InGame'
    case 'Planetman_Ossan_Paradise_1':
      return 'planetman_ossan_InGame'
    case 'Planetman_Planetman_1':
      return 'PlanetMan_1_InGame'
    case 'Planetman_Unicorn_1':
      return 'planetman_unicorn_InGame'
    case 'SignWitch_Ame_chan_1':
      return 'Signwitch_Pisces_InGame'
    case 'SignWitch_AstarCats_1':
      return 'Signwitch_GeminiA_InGame'
    case 'SignWitch_AstarCats_2':
      return 'Signwitch_GeminiB_InGame'
    case 'SignWitch_Faireaf_1':
      return 'Signwitch_Virgilia_InGame'
    case 'SignWitch_Hiyori_1':
      return 'Signwitch_Aquarius_InGame'
    case 'SignWitch_Layla_1':
      return 'Signwitch_Sagittarius_InGame'
    case 'SignWitch_P1_1':
      return 'Signwitch_Leo_InGame'
    case 'SignWitch_Planetman_1':
      return 'Signwitch_Libra_InGame'
    case 'SignWitch_SignWitch_1':
      return 'SignWitch_Aries_InGame'
    case 'SignWitch_Tofu_1':
      return 'SignWitch_Capricorn_InGame'
    case 'SignWitch_Unicorn_1':
      return 'Signwitch_Cancer_InGame'
    case 'SignWitch_UPA_1':
      return 'Signwitch_Scorpius_InGame'
    case 'SignWitch_Valius_1':
      return 'Signwitch_Taurus_InGame'
    case 'Tofu_DEKAUSA_1':
      return 'Tofu_Sainome_InGame'
    case 'Tofu_Golem_1':
      return 'Tofu_Konya_InGame'
    case 'Tofu_Icelime_1':
      return 'Tofu_Blue-mint_InGame'
    case 'Tofu_Planetman_1':
      return 'Tofu_Yaki-tofu_InGame'
    case 'Tofu_SignWitch_1':
      return 'Tofu_Neri-yokan_InGame'
    case 'Tofu_Tofu_1':
      return 'Tofu_1_InGame'
    case 'Tofu_Yamato_1':
      return 'Tofu_Timekeeper_InGame'
    case 'Unicorn_AstarCats_1':
      return 'Unicorn_Skywalker_InGame'
    case 'Unicorn_CCT_1':
      return 'Unicorn_Hanamiuma_InGame'
    case 'Unicorn_ODENPETS_1':
      return 'Unicorn_Soundhorse_InGame'
    case 'Unicorn_Planetman_1':
      return 'Unicorn_Burhimu_InGame'
    case 'Unicorn_Unicorn_1':
      return 'Unicorn_1_InGame'
    case 'Unicorn_UPA_1':
      return 'Unicorn_Kelpie_InGame'
    case 'Unicorn_Valius_1':
      return 'Unicorn_Crimson_InGame'
    case 'UPA_AstarCats_1':
      return 'UPA[AC]_InGame'
    case 'UPA_Golem_1':
      return 'UPA[Gorem]_InGame'
    case 'UPA_Kids_Villain_1':
      return 'UPA[Villain]_InGame'
    case 'UPA_ODENPETS_1':
      return 'UPA[ODEN]_InGame'
    case 'UPA_Ossan_Paradise_1':
      return 'UPA[Ossan]_InGame'
    case 'UPA_UPA_1':
      return 'UPA_1_InGame'
    case 'UPA_Yamato_1':
      return 'UPA[1912]_InGame'
    case 'Valius_CCT_1':
      return 'Valy_InGame'
    case 'Valius_DEKAUSA_1':
      return 'Braze hopper_InGame'
    case 'Valius_Kids_Villain_1':
      return 'Night-terror_InGame'
    case 'Valius_ODENPETS_1':
      return 'Stargazer_InGame'
    case 'Valius_Ossan_Paradise_1':
      return 'Sky-fang_InGame'
    case 'Valius_Unicorn_1':
      return 'Wolhorn_InGame'
    case 'Valius_Valius_1':
      return 'Valius_1_InGame'
    case 'Yamato_Ame_chan_1':
      return 'yamato_dress_InGame'
    case 'Yamato_AstarCats_1':
      return 'yamato_tshirt_InGame'
    case 'Yamato_ODENPETS_1':
      return 'yamato_waiter_InGame'
    case 'Yamato_P1_1':
      return 'yamato_X_InGame'
    case 'Yamato_Tofu_1':
      return 'yamato_white_InGame'
    case 'Yamato_UPA_1':
      return 'yamato_UPA_InGame'
    case 'Yamato_Yamato_1':
      return 'Yamato_1_InGame'
    default:
      return 'Signwitch_Carpicorn_InGame'
  }
}
export const getRankOverall = (rank) => {
  if (rank < 1400) {
    return 'F'
  } else if (rank < 2100) {
    return 'E'
  } else if (rank < 2800) {
    return 'D'
  } else if (rank < 4200) {
    return 'C'
  } else if (rank < 4900) {
    return 'B'
  } else if (rank < 5400) {
    return 'A'
  } else {
    return 'S'
  }
}
export const convertImageFamrOfMonster = (image) => {
  switch (image) {
    case 'Ame_chan_Ame_chan_1':
      return 'Volcano'
    case 'Ame_chan_Golem_1':
      return 'Volcano'
    case 'Ame_chan_Hiyori_1':
      return 'Volcano'
    case 'Ame_chan_Icelime_1':
      return 'Volcano'
    case 'Ame_chan_Kids_Villain_1':
      return 'Volcano'
    case 'Ame_chan_Layla_1':
      return 'Volcano'
    case 'Ame_chan_Yamato_1':
      return 'Volcano'
    case 'AstarCats_AstarCats_1':
      return 'Mountain'
    case 'AstarCats_Faireaf_1':
      return 'Mountain'
    case 'AstarCats_Hiyori_1':
      return 'Mountain'
    case 'AstarCats_Kids_Villain_1':
      return 'Mountain'
    case 'AstarCats_Ossan_Paradise_1':
      return 'Mountain'
    case 'AstarCats_SignWitch_1':
      return 'Mountain'
    case 'AstarCats_Tofu_1':
      return 'Mountain'
    case 'CCT_CCT_1':
      return 'Mountain'
    case 'CCT_CCT_2':
      return 'Desert'
    case 'CCT_CCT_3':
      return 'Plain'
    case 'CCT_CCT_4':
      return 'Wasteland'
    case 'DEKAUSA_CCT_1':
      return 'Volcano'
    case 'DEKAUSA_DEKAUSA_1':
      return 'Volcano'
    case 'DEKAUSA_Golem_1':
      return 'Volcano'
    case 'DEKAUSA_ODENPETS_1':
      return 'Volcano'
    case 'DEKAUSA_Planetman_1':
      return 'Volcano'
    case 'DEKAUSA_Tofu_1':
      return 'Volcano'
    case 'DEKAUSA_Yamato_1':
      return 'Volcano'
    case 'Faireaf_Ame_chan_1':
      return 'Forest'
    case 'Faireaf_Faireaf_1':
      return 'Forest'
    case 'Faireaf_Layla_1':
      return 'Forest'
    case 'Faireaf_P1_1':
      return 'Forest'
    case 'Faireaf_SignWitch_1':
      return 'Forest'
    case 'Faireaf_Tofu_1':
      return 'Forest'
    case 'Faireaf_Valius_1':
      return 'Forest'
    case 'Golem_DEKAUSA_1':
      return 'Wasteland'
    case 'Golem_Golem_1':
      return 'Wasteland'
    case 'Golem_Kids_Hero_1':
      return 'Wasteland'
    case 'Golem_Kids_Villain_1':
      return 'Wasteland'
    case 'Golem_Ossan_Paradise_1':
      return 'Wasteland'
    case 'Golem_Planetman_1':
      return 'Wasteland'
    case 'Golem_UPA_1':
      return 'Wasteland'
    case 'Hiyori_Ame_chan_1':
      return 'Plain'
    case 'Hiyori_Faireaf_1':
      return 'Plain'
    case 'Hiyori_Hiyori_1':
      return 'Plain'
    case 'Hiyori_Icelime_1':
      return 'Plain'
    case 'Hiyori_Layla_1':
      return 'Plain'
    case 'Hiyori_Unicorn_1':
      return 'Plain'
    case 'Hiyori_Valius_1':
      return 'Plain'
    case 'Icelime_CCT_1':
      return 'Forest'
    case 'Icelime_DEKAUSA_1':
      return 'Forest'
    case 'Icelime_Icelime_1':
      return 'Forest'
    case 'Icelime_Kids_Hero_1':
      return 'Forest'
    case 'Icelime_Unicorn_1':
      return 'Forest'
    case 'Icelime_UPA_1':
      return 'Forest'
    case 'Icelime_Yamato_1':
      return 'Forest'
    case 'Kids_Hero_Kids_Hero_1':
      return 'Plain'
    case 'Kids_Hero_Kids_Hero_2':
      return 'Plain'
    case 'Kids_Hero_Kids_Hero_3':
      return 'Plain'
    case 'Kids_Hero_Kids_Hero_4':
      return 'Plain'
    case 'Kids_Hero_Kids_Hero_5':
      return 'Plain'
    case 'Kids_Villain_Kids_Villain_1':
      return 'Volcano'
    case 'Kids_Villain_Kids_Villain_2':
      return 'Volcano'
    case 'Kids_Villain_Kids_Villain_3':
      return 'Volcano'
    case 'Kids_Villain_Kids_Villain_4':
      return 'Volcano'
    case 'Kids_Villain_Kids_Villain_5':
      return 'Volcano'
    case 'Layla_Faireaf_1':
      return 'Forest'
    case 'Layla_Hiyori_1':
      return 'Forest'
    case 'Layla_Icelime_1':
      return 'Forest'
    case 'Layla_Layla_1':
      return 'Forest'
    case 'Layla_P1_1':
      return 'Forest'
    case 'Layla_SignWitch_1':
      return 'Forest'
    case 'Layla_Valius_1':
      return 'Forest'
    case 'ODENPETS_Ame_chan_1':
      return 'Plain'
    case 'ODENPETS_DEKAUSA_1':
      return 'Plain'
    case 'ODENPETS_Kids_Hero_1':
      return 'Forest'
    case 'ODENPETS_ODENPETS_1':
      return 'Forest'
    case 'ODENPETS_P1_1':
      return 'Forest'
    case 'Ossan_Paradise_Ossan_Paradise_1':
      return 'Plain'
    case 'Ossan_Paradise_Ossan_Paradise_2':
      return 'Plain'
    case 'Ossan_Paradise_Ossan_Paradise_3':
      return 'Plain'
    case 'Ossan_Paradise_Ossan_Paradise_4':
      return 'Plain'
    case 'Ossan_Paradise_Ossan_Paradise_5':
      return 'Plain'
    case 'P1_Faireaf_1':
      return 'Desert'
    case 'P1_Hiyori_1':
      return 'Desert'
    case 'P1_Icelime_1':
      return 'Desert'
    case 'P1_Kids_Hero_1':
      return 'Desert'
    case 'P1_Layla_1':
      return 'Desert'
    case 'P1_P1_1':
      return 'Desert'
    case 'P1_SignWitch_1':
      return 'Desert'
    case 'Planetman_AstarCats_1':
      return 'Wasteland'
    case 'Planetman_CCT_1':
      return 'Wasteland'
    case 'Planetman_Golem_1':
      return 'Wasteland'
    case 'Planetman_Kids_Hero_1':
      return 'Wasteland'
    case 'Planetman_Ossan_Paradise_1':
      return 'Wasteland'
    case 'Planetman_Planetman_1':
      return 'Wasteland'
    case 'Planetman_Unicorn_1':
      return 'Wasteland'
    case 'SignWitch_Ame_chan_1':
      return 'Wasteland'
    case 'SignWitch_AstarCats_1':
      return 'Forest'
    case 'SignWitch_AstarCats_2':
      return 'Volcano'
    case 'SignWitch_Faireaf_1':
      return 'Waterfront'
    case 'SignWitch_Hiyori_1':
      return 'Waterfront'
    case 'SignWitch_Layla_1':
      return 'Forest'
    case 'SignWitch_P1_1':
      return 'Volcano'
    case 'SignWitch_Planetman_1':
      return 'Mountain'
    case 'SignWitch_SignWitch_1':
      return 'Mountain'
    case 'SignWitch_Tofu_1':
      return 'Forest'
    case 'SignWitch_Unicorn_1':
      return 'Desert'
    case 'SignWitch_UPA_1':
      return 'Plain'
    case 'SignWitch_Valius_1':
      return 'Wasteland'
    case 'Tofu_DEKAUSA_1':
      return 'Desert'
    case 'Tofu_Golem_1':
      return 'Desert'
    case 'Tofu_Icelime_1':
      return 'Desert'
    case 'Tofu_Planetman_1':
      return 'Desert'
    case 'Tofu_SignWitch_1':
      return 'Desert'
    case 'Tofu_Tofu_1':
      return 'Desert'
    case 'Tofu_Yamato_1':
      return 'Desert'
    case 'Unicorn_AstarCats_1':
      return 'Plain'
    case 'Unicorn_CCT_1':
      return 'Plain'
    case 'Unicorn_ODENPETS_1':
      return 'Plain'
    case 'Unicorn_Planetman_1':
      return 'Plain'
    case 'Unicorn_Unicorn_1':
      return 'Plain'
    case 'Unicorn_UPA_1':
      return 'Plain'
    case 'Unicorn_Valius_1':
      return 'Plain'
    case 'UPA_AstarCats_1':
      return 'Waterfront'
    case 'UPA_Golem_1':
      return 'Waterfront'
    case 'UPA_Kids_Villain_1':
      return 'Waterfront'
    case 'UPA_ODENPETS_1':
      return 'Waterfront'
    case 'UPA_Ossan_Paradise_1':
      return 'Waterfront'
    case 'UPA_UPA_1':
      return 'Waterfront'
    case 'UPA_Yamato_1':
      return 'Waterfront'
    case 'Valius_CCT_1':
      return 'Mountain'
    case 'Valius_DEKAUSA_1':
      return 'Mountain'
    case 'Valius_Kids_Villain_1':
      return 'Mountain'
    case 'Valius_ODENPETS_1':
      return 'Mountain'
    case 'Valius_Ossan_Paradise_1':
      return 'Mountain'
    case 'Valius_Unicorn_1':
      return 'Mountain'
    case 'Valius_Valius_1':
      return 'Mountain'
    case 'Yamato_Ame_chan_1':
      return 'Waterfront'
    case 'Yamato_AstarCats_1':
      return 'Waterfront'
    case 'Yamato_ODENPETS_1':
      return 'Waterfront'
    case 'Yamato_P1_1':
      return 'Waterfront'
    case 'Yamato_Tofu_1':
      return 'Waterfront'
    case 'Yamato_UPA_1':
      return 'Waterfront'
    case 'Yamato_Yamato_1':
      return 'Waterfront'
    default:
      return ''
  }
}
export const converImageCollection = (seed) => {
  switch (seed) {
    case 'Faireaf':
      return 'reMonster'
    case 'Golem':
      return 'reMonster'
    case 'Tofu':
      return 'reMonster'
    case 'Unicorn':
      return 'reMonster'
    case 'Valius':
      return 'reMonster'
    case 'AstarCats':
      return 'astarcats'
    case 'SignWitch':
      return 'astarsignWitch'
    case 'Layla':
      return 'loveaddictedgirls'
    case 'ODENPETS':
      return 'odenpets'
    case 'UPA':
      return 'upa'
    case 'Hiyori':
      return 'wafukugen'
    case 'Yamato':
      return '1912'
    case 'DEKAUSA':
      return 'allemon'
    case 'CCT':
      return 'candyconytown'
    case 'Icelime':
      return 'eien'
    case 'Ame_chan':
      return 'kawaiiGIrlNFT'
    case 'Kids_Hero':
      return 'kidsfight'
    case 'Kids_Villain':
      return 'kidsfight'
    case 'Sake_Barrel_PlanetMan':
      return 'metaX'
    case 'Planetman':
      return 'metaX'
    case 'P1':
      return 'xsoldiers'
    case 'Ossan_Paradise':
      return 'ossanparadise'
    default:
      return ''
  }
}
export const extractConvertMonsterSeed = (monster_script_id) => {
  if (!monster_script_id) return { mainSeed: '', subSeed: '' }

  const specialTerms = [
    'Ossan_Paradise',
    'Kids_Villain',
    'Kids_Hero',
    'Ame_chan',
  ]

  const parts = monster_script_id.split('_')
  const lastPart = parts.pop()

  let subSeed = ''
  let mainSeed = ''
  for (let i = parts.length; i > 0; i--) {
    const possiblePart2 = parts.slice(i - 1).join('_')
    if (specialTerms.includes(possiblePart2)) {
      subSeed = possiblePart2
      mainSeed = parts.slice(0, i - 1).join('_')
      break
    }
  }

  if (!subSeed) {
    subSeed = parts.pop()
    mainSeed = parts.join('_')
  }

  return { mainSeed, subSeed }
}
export const convertSeed = (seed) => {
  switch (seed) {
    case 1:
      return 'Re.Monster'
    case 2:
      return 'Re.Monster'
    case 3:
      return 'Re.Monster'
    case 4:
      return 'Re.Monster'
    case 5:
      return 'Re.Monster'
    case 6:
      return 'ODENDAO'
    case 7:
      return 'Astar Sign Witch'
    case 8:
      return 'Love Addicted Girls'
    case 9:
      return 'ODENDAO'
    case 10:
      return 'DeBreed'
    case 11:
      return 'Wafuku'
    case 12:
      return '1912'
    case 13:
      return 'ALKEMON'
    case 14:
      return 'Candy Cony Town'
    case 15:
      return 'EIEN'
    case 16:
      return 'KawaiiGIrl NFT'
    case 17:
      return 'Kids Fight'
    case 18:
      return 'Kids Fight'
    case 19:
      return 'PlanetMan'
    case 20:
      return 'X Soldiers'
    case 21:
      return 'Ossan Paradise'
    default:
      return null
  }
}
export const TournamentType = (type) => {
  switch (type) {
    case 0:
      return 'Elimination'
    case 1:
      return 'Elimination'
    default:
      return ''
  }
}
export const SpecialHexType = (type) => {
  switch (type) {
    case 0:
      return 'Random'
    case 1:
      return 'Unmovable'
    case 2:
      return 'Damage'
    case 3:
      return 'None'
    default:
      return ''
  }
}
export const MonsterTypeTournament = (type) => {
  const mapping = {
    0: 'Free',
    1: 'Regeneration',
    2: 'Fusion',
    3: 'Gift',
  }

  if (Array.isArray(type)) {
    return type.map((value) => mapping[value] || value).join('/')
  }

  if (typeof type === 'string') {
    return type
      .split('')
      .map((char) => mapping[char] || char)
      .join('/')
  }

  // Xử lý trường hợp là số
  return mapping[type] || type || ''
}

export const seed = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
]
const authToken = localStorage.getItem('auth_token')
export const handleExportCSVScreen = async (screen, dataToSubmit, nameFile) => {
  const { pageSize, page, ...filteredData } = dataToSubmit

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/export-csv/${screen}`,
      filteredData,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
        responseType: 'blob',
      },
    )
    const blob = new Blob([response.data], {
      type: response.headers['content-type'],
    })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.style.display = 'none'
    a.href = url
    a.download = `${nameFile}.xlsx`
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)
  } catch (error) {
    console.error('Error downloading file:', error)
  }
}

export const HistoryHashChipNftRewardRank = [
  "Monster Rank E",      // 0
  "Monster Rank D",      // 1
  "Monster Rank C",      // 2
  "Monster Rank B",      // 3
  "Monster Rank A",      // 4
  "Monster Regen 1",     // 5
  "Monster Regen 2",     // 6
  "Monster Regen 3",     // 7
  "Monster Fusion 1",    // 8
  "Monster Fusion 2",    // 9
  "Coach 1",            // 10
  "Coach 2",            // 11
  "Crystal 1",          // 12
  "Crystal 2",          // 13
  "Ranked Match 1",     // 14
  "Ranked Match 5",     // 15
  "Ranked Match 10",    // 16
  "Exploration 1",      // 17
  "Exploration 5",      // 18
  "Exploration 10"      // 19
]
